export enum API_ACCESSRIGHTSENTRY_ACCESSLEVEL {
    VIEW = 'VIEW',
    VIEW_WATERMARKED = 'VIEW_WATERMARKED',
    READONLY = 'READONLY',
    WRITE = 'WRITE',
    OWNER_FILES = 'OWNER_FILES',
    OWNER_FILES_AND_FOLDERS = 'OWNER_FILES_AND_FOLDERS',
}
export enum API_ACCESSUSERRIGHT_RIGHT {
    VIEW = 'VIEW',
    VIEW_WATERMARKED = 'VIEW_WATERMARKED',
    READONLY = 'READONLY',
    WRITE = 'WRITE',
    OWNER_FILES = 'OWNER_FILES',
    OWNER_FILES_AND_FOLDERS = 'OWNER_FILES_AND_FOLDERS',
}
export enum API_ACTIONINFOREST_STATUS {
    STARTED = 'STARTED',
    WAITING = 'WAITING',
    IN_PROGRESS = 'IN_PROGRESS',
    FINISHED = 'FINISHED',
    ABORTED = 'ABORTED',
    ERROR = 'ERROR',
    UNDEFINED = 'UNDEFINED',
}
export enum API_ACTIVITY_ACCESS {
    READ = 'READ',
    CHANGE = 'CHANGE',
}
export enum API_ACTIVITY_TYPE {
    FILE = 'FILE',
    MAIL_INTERN = 'MAIL_INTERN',
    MAIL_EXTERN = 'MAIL_EXTERN',
}
export enum API_ACTIVITYREPORTREQUEST_EVENT {
    LOGIN = 'LOGIN',
    VIEW = 'VIEW',
}
export enum API_ACTIVITYREPORTREQUEST_RATE {
    DAY = 'DAY',
    WEEK = 'WEEK',
    MONTH = 'MONTH',
}
export enum API_ADMIN_PROJECTS_SORTBY {
    ID = 'ID',
    NAME = 'NAME',
    SHORT_NAME = 'SHORT_NAME',
    DESCRIPTION = 'DESCRIPTION',
    TYPE = 'TYPE',
}
export enum API_ADMIN_PROJECTS_SORTORDER {
    ASC = 'ASC',
    DESC = 'DESC',
}
export enum API_ADMIN_SORTBY {
    TIME = 'TIME',
    LOGTYPE = 'LOGTYPE',
    ACTOR = 'ACTOR',
    IP = 'IP',
}
export enum API_ADMIN_SORTORDER {
    ASC = 'ASC',
    DESC = 'DESC',
}
export enum API_ADMIN_TARGETTYPE {
    USER = 'USER',
    PROJECT = 'PROJECT',
    PROJECTGROUP = 'PROJECTGROUP',
}
export enum API_ADMIN_TEMPLATES_SORTBY {
    ID = 'ID',
    NAME = 'NAME',
    SHORT_NAME = 'SHORT_NAME',
    DESCRIPTION = 'DESCRIPTION',
    TYPE = 'TYPE',
}
export enum API_ADMIN_TEMPLATES_SORTORDER {
    ASC = 'ASC',
    DESC = 'DESC',
}
export enum API_ADMINLOGFILTER_TARGETTYPE {
    USER = 'USER',
    PROJECT = 'PROJECT',
    PROJECTGROUP = 'PROJECTGROUP',
}
export enum API_ADMINLOGPAGINATION_SORTORDER {
    ASC = 'ASC',
    DESC = 'DESC',
}
export enum API_ADMINPROJECT_LOGINMODE {
    STANDARD = 'STANDARD',
    NO_GUESTS = 'NO_GUESTS',
    MFA_FOR_ALL_USERS_ALLOW_GUESTS = 'MFA_FOR_ALL_USERS_ALLOW_GUESTS',
    MFA_FOR_ALL_USERS_FORBID_GUESTS = 'MFA_FOR_ALL_USERS_FORBID_GUESTS',
}
export enum API_ADMINPROJECT_PRESET {
    PAVECDE = 'PAVECDE',
    PAVEEASY = 'PAVEEASY',
    PAVEBASIC = 'PAVEBASIC',
    PAVEBUSINESS = 'PAVEBUSINESS',
    PAVEENTERPRISE = 'PAVEENTERPRISE',
}
export enum API_ADMINPROJECT_READACCESSTORIGHTS {
    VIEW = 'VIEW',
    VIEW_WATERMARKED = 'VIEW_WATERMARKED',
    READONLY = 'READONLY',
    WRITE = 'WRITE',
    OWNER_FILES = 'OWNER_FILES',
    OWNER_FILES_AND_FOLDERS = 'OWNER_FILES_AND_FOLDERS',
}
export enum API_ADMINPROJECT_STARTWITH {
    MAIL = 'MAIL',
    DOCUMENTS = 'DOCUMENTS',
    VIEW = 'VIEW',
    QA = 'QA',
    BIM = 'BIM',
    TASKS = 'TASKS',
    WORKFLOW = 'WORKFLOW',
    TENDER_MODERN = 'TENDER_MODERN',
    TENDER = 'TENDER',
    LOP = 'LOP',
    CALENDAR = 'CALENDAR',
    OX_MODULES = 'OX_MODULES',
    CONSTRUCTIONLOG = 'CONSTRUCTIONLOG',
    ONLINEBAUABNAHME = 'ONLINEBAUABNAHME',
    OX_FOTOS = 'OX_FOTOS',
    OX_CHECKLISTS = 'OX_CHECKLISTS',
    CLAIMDOC = 'CLAIMDOC',
    WEBCAM = 'WEBCAM',
    EAKTE = 'EAKTE',
    CONTRACTMANAGEMENT = 'CONTRACTMANAGEMENT',
    PROTOCOLLMANAGEMENT = 'PROTOCOLLMANAGEMENT',
    RESOLUTIONS = 'RESOLUTIONS',
    ORGANIZATIONS = 'ORGANIZATIONS',
    CLAIM_COCKPIT = 'CLAIM_COCKPIT',
    INVESTIGATIONS = 'INVESTIGATIONS',
    PLAN_DELIVERY_LIST = 'PLAN_DELIVERY_LIST',
    VALUE_TABLE = 'VALUE_TABLE',
    PROJECT_MANAGMENT = 'PROJECT_MANAGMENT',
    BIM_ISSUES = 'BIM_ISSUES',
    DOCUMENTS_AND_PLANS = 'DOCUMENTS_AND_PLANS',
    KPI_DASHBOARD = 'KPI_DASHBOARD',
    STA_INTEGRATION = 'STA_INTEGRATION',
}
export enum API_ADMINPROJECT_STATUS {
    ENABLED = 'ENABLED',
    ARCHIVED = 'ARCHIVED',
    DEACTIVATED = 'DEACTIVATED',
}
export enum API_ADMINPROJECT_TYPE {
    NONE = 'NONE',
    CLASSIC = 'CLASSIC',
    MODERN = 'MODERN',
}
export enum API_ADMINPROJECT_TYPESECRETCLOUD {
    NONE = 'NONE',
    PROTECTED = 'PROTECTED',
    HIGH_SECURE = 'HIGH_SECURE',
    HSM = 'HSM',
}
export enum API_ADMINPROJECTPAGINATION_SORTBY {
    ID = 'ID',
    NAME = 'NAME',
    SHORT_NAME = 'SHORT_NAME',
    DESCRIPTION = 'DESCRIPTION',
    TYPE = 'TYPE',
}
export enum API_ADMINPROJECTPAGINATION_SORTORDER {
    ASC = 'ASC',
    DESC = 'DESC',
}
export enum API_ADMINPROJECTREQUESTASSIGNMENT_PROJECTROLE {
    ADMIN = 'ADMIN',
    USER = 'USER',
    HID = 'HID',
    INFO = 'INFO',
    ARCHIVE_ADMIN = 'ARCHIVE_ADMIN',
    NONE = 'NONE',
}
export enum API_ANSWER_STATUS {
    UNKNOWN = 'UNKNOWN',
    DRAFT = 'DRAFT',
    WITHDRAWN = 'WITHDRAWN',
    IN_ADMISSION = 'IN_ADMISSION',
    NOT_ADMITTED = 'NOT_ADMITTED',
    IN_ACCEPTANCE = 'IN_ACCEPTANCE',
    NOT_ACCEPTED = 'NOT_ACCEPTED',
    ACCEPTED = 'ACCEPTED',
    IN_PROGRESS = 'IN_PROGRESS',
    IN_CATEGORY_APPROVAL = 'IN_CATEGORY_APPROVAL',
    IN_FIRST_STAGE_APPROVAL = 'IN_FIRST_STAGE_APPROVAL',
    IN_SECOND_STAGE_APPROVAL = 'IN_SECOND_STAGE_APPROVAL',
    ANSWER_REJECTED = 'ANSWER_REJECTED',
    APPROVED = 'APPROVED',
}
export enum API_ARCHIVEDOBJECT_EXTRACTMODE {
    NONE = 'NONE',
    EXTRACT_FLAT = 'EXTRACT_FLAT',
    EXTRACT_WITH_DIRECTORY = 'EXTRACT_WITH_DIRECTORY',
    EXTRACT_WITH_EMPTY_DIRECTORY = 'EXTRACT_WITH_EMPTY_DIRECTORY',
}
export enum API_BASEDATAENTITY_STATE {
    ACTIVE = 'ACTIVE',
    ARCHIVED = 'ARCHIVED',
    LOCKED = 'LOCKED',
    SYMLINK = 'SYMLINK',
    DELETED = 'DELETED',
    EXTERN_SYMLINK = 'EXTERN_SYMLINK',
}
export enum API_BASEUSER_LASTENVIRONMENT {
    NONE = 'NONE',
    CLASSIC = 'CLASSIC',
    MODERN = 'MODERN',
}
export enum API_BASICLOGIN_TYPE {
    WEB = 'Web',
    MOBILEAPP = 'MobileApp',
    OAUTH = 'Oauth',
}
export enum API_BCFEXPORTREQUEST_BCFVERSION {
    BCF_3_0 = 'BCF_3_0',
    BCF_2_1 = 'BCF_2_1',
    BCF_2_0 = 'BCF_2_0',
}
export enum API_BCFIMPORTFILE_FILESTATUS {
    NEW = 'NEW',
    UNCHANGED = 'UNCHANGED',
    RETAINED = 'RETAINED',
}
export enum API_BCFIMPORTREQUESTCONFLICT_EXTENSIONTYPE {
    TOPIC = 'TOPIC',
    TITLE = 'TITLE',
    STATUS = 'STATUS',
    PRIORITY = 'PRIORITY',
    STAGE = 'STAGE',
    TYPE = 'TYPE',
    LABEL = 'LABEL',
    USER = 'USER',
    FILE = 'FILE',
}
export enum API_BCFSERVERBITMAP_BITMAP_TYPE {
    JPG = 'jpg',
    PNG = 'png',
}
export enum API_BCFSERVERCOMMENTAUTHORIZATION_COMMENT_ACTIONS {
    UPDATE = 'update',
    DELETE = 'delete',
}
export enum API_BCFSERVERCOMMENTEVENTACTIONDATA_TYPE {
    COMMENT_CREATED = 'comment_created',
    COMMENT_TEXT_UPDATED = 'comment_text_updated',
    VIEWPOINT_UPDATED = 'viewpoint_updated',
    VIEWPOINT_REMOVED = 'viewpoint_removed',
}
export enum API_BCFSERVERFILTERREQUEST_ORDERBY {
    TITLE = 'TITLE',
    DESCRIPTION = 'DESCRIPTION',
    PRIORITY = 'PRIORITY',
    DUE_DATE = 'DUE_DATE',
    TOPIC_STATUS = 'TOPIC_STATUS',
    ASSIGNED_TO = 'ASSIGNED_TO',
    TOPIC_TYPE = 'TOPIC_TYPE',
    CREATION_DATE = 'CREATION_DATE',
    LABELS = 'LABELS',
    STAGE = 'STAGE',
}
export enum API_BCFSERVERFILTERREQUEST_SORTORDER {
    ASC = 'ASC',
    DESC = 'DESC',
}
export enum API_BCFSERVERPROJECTAUTHORIZATION_PROJECT_ACTIONS {
    READISSUES = 'readIssues',
    CREATEDOCUMENT = 'createDocument',
    CREATETOPIC = 'createTopic',
    UPDATE = 'update',
}
export enum API_BCFSERVERPROJECTEXTENSIONS_ADDITIONAL_TOPIC_ACTIONS {
    READISSUES = 'readIssues',
}
export enum API_BCFSERVERPROJECTEXTENSIONS_COMMENT_ACTIONS {
    UPDATE = 'update',
    DELETE = 'delete',
}
export enum API_BCFSERVERPROJECTEXTENSIONS_PROJECT_ACTIONS {
    READISSUES = 'readIssues',
    CREATEDOCUMENT = 'createDocument',
    CREATETOPIC = 'createTopic',
    UPDATE = 'update',
}
export enum API_BCFSERVERPROJECTEXTENSIONS_TOPIC_ACTIONS {
    UPDATEBIMSNIPPET = 'updateBimSnippet',
    UPDATERELATEDTOPICS = 'updateRelatedTopics',
    UPDATEDOCUMENTREFERENCES = 'updateDocumentReferences',
    UPDATEFILES = 'updateFiles',
    CREATECOMMENT = 'createComment',
    CREATEVIEWPOINT = 'createViewpoint',
    UPDATE = 'update',
    DELETE = 'delete',
}
export enum API_BCFSERVERPROJECTEXTENSIONS_VIEWPOINT_ACTIONS {
    DELETE = 'delete',
}
export enum API_BCFSERVERSNAPSHOT_SNAPSHOT_TYPE {
    JPG = 'jpg',
    PNG = 'png',
}
export enum API_BCFSERVERTOPICAUTHORIZATION_TOPIC_ACTIONS {
    UPDATEBIMSNIPPET = 'updateBimSnippet',
    UPDATERELATEDTOPICS = 'updateRelatedTopics',
    UPDATEDOCUMENTREFERENCES = 'updateDocumentReferences',
    UPDATEFILES = 'updateFiles',
    CREATECOMMENT = 'createComment',
    CREATEVIEWPOINT = 'createViewpoint',
    UPDATE = 'update',
    DELETE = 'delete',
}
export enum API_BCFSERVERTOPICEVENTACTIONDATA_TYPE {
    TOPIC_CREATED = 'topic_created',
    TITLE_UPDATED = 'title_updated',
    DESCRIPTION_UPDATED = 'description_updated',
    DESCRIPTION_REMOVED = 'description_removed',
    STATUS_UPDATED = 'status_updated',
    TYPE_UPDATED = 'type_updated',
    PRIORITY_UPDATED = 'priority_updated',
    PRIORITY_REMOVED = 'priority_removed',
    DUE_DATE_UPDATED = 'due_date_updated',
    DUE_DATE_REMOVED = 'due_date_removed',
    ASSIGNED_TO_UPDATED = 'assigned_to_updated',
    ASSIGNED_TO_REMOVED = 'assigned_to_removed',
    LABEL_ADDED = 'label_added',
    LABEL_REMOVED = 'label_removed',
    STAGE_ADDED = 'stage_added',
    STAGE_UPDATED = 'stage_updated',
    STAGE_REMOVED = 'stage_removed',
}
export enum API_BCFSERVERVIEWPOINTAUTHORIZATION_VIEWPOINT_ACTIONS {
    DELETE = 'delete',
}
export enum API_BIDDERDATA_LANGUAGE {
    DE = 'DE',
    EN = 'EN',
}
export enum API_BIDDERLOGINDATA_LANGUAGE {
    DE = 'DE',
    EN = 'EN',
}
export enum API_BIDDERLOGINDATA_STATUS {
    ADDED = 'ADDED',
    INVITED = 'INVITED',
    LOGGED_IN = 'LOGGED_IN',
    ACCEPT_INVITE = 'ACCEPT_INVITE',
    DENIED = 'DENIED',
    UPLOADED_FILES = 'UPLOADED_FILES',
    PLACED_BID = 'PLACED_BID',
    DENIED_LATER = 'DENIED_LATER',
    NEGATIVE_REPLY = 'NEGATIVE_REPLY',
}
export enum API_BIDDERPAGINATION_SORTORDER {
    ASC = 'ASC',
    DESC = 'DESC',
}
export enum API_BIDDERPARTICIPANT_BIDDERSTATUS {
    ADDED = 'ADDED',
    INVITED = 'INVITED',
    LOGGED_IN = 'LOGGED_IN',
    ACCEPT_INVITE = 'ACCEPT_INVITE',
    DENIED = 'DENIED',
    UPLOADED_FILES = 'UPLOADED_FILES',
    PLACED_BID = 'PLACED_BID',
    DENIED_LATER = 'DENIED_LATER',
    NEGATIVE_REPLY = 'NEGATIVE_REPLY',
}
export enum API_BIDDERPOOLDATA_ACCESSLEVEL {
    FULL = 'FULL',
    READONLY = 'READONLY',
    DENIED = 'DENIED',
}
export enum API_BILLINGCONTACT_TYPE {
    BILLING = 'BILLING',
    CONTACT = 'CONTACT',
    SALES = 'SALES',
}
export enum API_BILLINGINFORMATION_BILLINGMODE {
    FREE = 'FREE',
    STORAGE_AND_USER = 'STORAGE_AND_USER',
    STORAGE_IN_GB = 'STORAGE_IN_GB',
    STORAGE_IN_PAGES = 'STORAGE_IN_PAGES',
}
export enum API_BUTTONREST_TYPE {
    SUBMIT = 'SUBMIT',
}
export enum API_CALENDAREVENTDTO_EVENTTYPE {
    TEAM_BUILDING = 'TEAM_BUILDING',
    INFORMATION_SHARING = 'INFORMATION_SHARING',
}
export enum API_CALENDAREVENTREQUEST_EVENTTYPE {
    TEAM_BUILDING = 'TEAM_BUILDING',
    INFORMATION_SHARING = 'INFORMATION_SHARING',
}
export enum API_CALLFORTENDERCREATEDETAILS_REMINDERTIME {
    HOURS_24 = 'HOURS_24',
    HOURS_48 = 'HOURS_48',
    HOURS_72 = 'HOURS_72',
}
export enum API_CALLFORTENDERDETAILS_REMINDERTIME {
    HOURS_24 = 'HOURS_24',
    HOURS_48 = 'HOURS_48',
    HOURS_72 = 'HOURS_72',
}
export enum API_CALLFORTENDERDETAILS_STATUS {
    INITIALIZED = 'INITIALIZED',
    ABORTED = 'ABORTED',
    RUNNING = 'RUNNING',
    IN_REVIEW = 'IN_REVIEW',
    IN_INSPECTION = 'IN_INSPECTION',
    FINISHED = 'FINISHED',
}
export enum API_CALLFORTENDERLISTENTRY_STATUS {
    INITIALIZED = 'INITIALIZED',
    ABORTED = 'ABORTED',
    RUNNING = 'RUNNING',
    IN_REVIEW = 'IN_REVIEW',
    IN_INSPECTION = 'IN_INSPECTION',
    FINISHED = 'FINISHED',
}
export enum API_CALLFORTENDERSTATISTICS_ACCESSLEVEL {
    FULL = 'FULL',
    READONLY = 'READONLY',
    DENIED = 'DENIED',
}
export enum API_CALLNOTIFICATION_PURPOSE {
    BIDDER_INVITATION = 'BIDDER_INVITATION',
    REVIEW_START = 'REVIEW_START',
    INSPECTION_START = 'INSPECTION_START',
    EVALUATION_START = 'EVALUATION_START',
    BIDDER_NEGATIVE_REPLY = 'BIDDER_NEGATIVE_REPLY',
    CFT_CHANGED_DETAILS = 'CFT_CHANGED_DETAILS',
    CFT_CHANGED_BIDDING_END = 'CFT_CHANGED_BIDDING_END',
    REMINDER = 'REMINDER',
    RESEND_ACCESS = 'RESEND_ACCESS',
    BIDDER_DEACTIVATED = 'BIDDER_DEACTIVATED',
}
export enum API_CALLTEMPLATECHANGE_PURPOSE {
    BIDDER_INVITATION = 'BIDDER_INVITATION',
    REVIEW_START = 'REVIEW_START',
    INSPECTION_START = 'INSPECTION_START',
    EVALUATION_START = 'EVALUATION_START',
    BIDDER_NEGATIVE_REPLY = 'BIDDER_NEGATIVE_REPLY',
    CFT_CHANGED_DETAILS = 'CFT_CHANGED_DETAILS',
    CFT_CHANGED_BIDDING_END = 'CFT_CHANGED_BIDDING_END',
    REMINDER = 'REMINDER',
    RESEND_ACCESS = 'RESEND_ACCESS',
    BIDDER_DEACTIVATED = 'BIDDER_DEACTIVATED',
}
export enum API_CATEGORYFILEDATAENTITY_RELATIONS {
    MASTER = 'MASTER',
    SLAVE = 'SLAVE',
    SYMLINK = 'SYMLINK',
    ORIGINAL = 'ORIGINAL',
    TASK = 'TASK',
    WORKFLOW = 'WORKFLOW',
    QUESTION = 'QUESTION',
}
export enum API_CATEGORYFILEDATAENTITY_STATE {
    ACTIVE = 'ACTIVE',
    ARCHIVED = 'ARCHIVED',
    LOCKED = 'LOCKED',
    SYMLINK = 'SYMLINK',
    DELETED = 'DELETED',
    EXTERN_SYMLINK = 'EXTERN_SYMLINK',
}
export enum API_CFTFILE_ACCESSLEVEL {
    FULL = 'FULL',
    READONLY = 'READONLY',
    DENIED = 'DENIED',
}
export enum API_CFTFOLDER_ACCESSLEVEL {
    FULL = 'FULL',
    READONLY = 'READONLY',
    DENIED = 'DENIED',
}
export enum API_CFTOFFERDETAILS_BIDDERSTATUS {
    ADDED = 'ADDED',
    INVITED = 'INVITED',
    LOGGED_IN = 'LOGGED_IN',
    ACCEPT_INVITE = 'ACCEPT_INVITE',
    DENIED = 'DENIED',
    UPLOADED_FILES = 'UPLOADED_FILES',
    PLACED_BID = 'PLACED_BID',
    DENIED_LATER = 'DENIED_LATER',
    NEGATIVE_REPLY = 'NEGATIVE_REPLY',
}
export enum API_CFTOFFERDETAILS_OFFERSTATUS {
    OFFER_INCOMPLETE = 'OFFER_INCOMPLETE',
    OFFER_SUM_MISSING = 'OFFER_SUM_MISSING',
    FILES_MISSING = 'FILES_MISSING',
    OFFER_COMPLETE = 'OFFER_COMPLETE',
}
export enum API_CFTOFFERSETTINGS_CURRENCY {
    EURO = 'Euro',
    DOLLAR = 'Dollar',
}
export enum API_CFTOFFERSETTINGS_OFFERTYPE {
    GROSS = 'GROSS',
    NET = 'NET',
    INACTIVE = 'INACTIVE',
}
export enum API_CFTSENDERSETTINGS_SENDEROPTION {
    CALL_CREATOR = 'CALL_CREATOR',
    CURRENT_USER = 'CURRENT_USER',
    PROJECT_OPTION = 'PROJECT_OPTION',
    SYSTEM = 'SYSTEM',
}
export enum API_CFTSIGNATURESETTINGS_SIGNATUREOPTION {
    SENDER = 'SENDER',
    CALL_CREATOR = 'CALL_CREATOR',
    CALL_CLIENT = 'CALL_CLIENT',
    CUSTOM = 'CUSTOM',
    PROJECT_OPTION = 'PROJECT_OPTION',
    NONE = 'NONE',
}
export enum API_CHUNKUPLOADDETAILS_MODULE {
    MAIL = 'MAIL',
    DOCUMENTS = 'DOCUMENTS',
    VIEW = 'VIEW',
    QA = 'QA',
    BIM = 'BIM',
    TASKS = 'TASKS',
    WORKFLOW = 'WORKFLOW',
    TENDER_MODERN = 'TENDER_MODERN',
    TENDER = 'TENDER',
    LOP = 'LOP',
    CALENDAR = 'CALENDAR',
    OX_MODULES = 'OX_MODULES',
    CONSTRUCTIONLOG = 'CONSTRUCTIONLOG',
    ONLINEBAUABNAHME = 'ONLINEBAUABNAHME',
    OX_FOTOS = 'OX_FOTOS',
    OX_CHECKLISTS = 'OX_CHECKLISTS',
    CLAIMDOC = 'CLAIMDOC',
    WEBCAM = 'WEBCAM',
    EAKTE = 'EAKTE',
    CONTRACTMANAGEMENT = 'CONTRACTMANAGEMENT',
    PROTOCOLLMANAGEMENT = 'PROTOCOLLMANAGEMENT',
    RESOLUTIONS = 'RESOLUTIONS',
    ORGANIZATIONS = 'ORGANIZATIONS',
    CLAIM_COCKPIT = 'CLAIM_COCKPIT',
    INVESTIGATIONS = 'INVESTIGATIONS',
    PLAN_DELIVERY_LIST = 'PLAN_DELIVERY_LIST',
    VALUE_TABLE = 'VALUE_TABLE',
    PROJECT_MANAGMENT = 'PROJECT_MANAGMENT',
    BIM_ISSUES = 'BIM_ISSUES',
    DOCUMENTS_AND_PLANS = 'DOCUMENTS_AND_PLANS',
    KPI_DASHBOARD = 'KPI_DASHBOARD',
    STA_INTEGRATION = 'STA_INTEGRATION',
}
export enum API_CLIENTAPP_APPSECURITYTYPE {
    JWT = 'JWT',
    OAUTH2 = 'OAUTH2',
}
export enum API_CLIENTAPP_SECRETTYPE {
    SIMPLE = 'SIMPLE',
    BCRYPT = 'BCRYPT',
}
export enum API_CLIENTAPP_TYPE {
    EXTERNAL_APP = 'EXTERNAL_APP',
    MOBILE_APP = 'MOBILE_APP',
}
export enum API_COLUMNDEFINITION_TYPE {
    USER = 'USER',
    GROUP = 'GROUP',
    REMOVED_USER = 'REMOVED_USER',
}
export enum API_COLUMNVALUE_OBJECTTYPE {
    USER = 'USER',
    GROUP = 'GROUP',
    REMOVED_USER = 'REMOVED_USER',
}
export enum API_COLUMNVALUE_TYPE {
    UNDEFINED = 'UNDEFINED',
    ACCESS = 'ACCESS',
    NO_ACCESS = 'NO_ACCESS',
    SUSPICIOUS = 'SUSPICIOUS',
    CONFLICT = 'CONFLICT',
}
export enum API_COLUMNVALUEUPDATE_OBJECTTYPE {
    USER = 'USER',
    GROUP = 'GROUP',
    REMOVED_USER = 'REMOVED_USER',
}
export enum API_COLUMNVALUEUPDATE_TYPE {
    UNDEFINED = 'UNDEFINED',
    ACCESS = 'ACCESS',
    NO_ACCESS = 'NO_ACCESS',
    SUSPICIOUS = 'SUSPICIOUS',
    CONFLICT = 'CONFLICT',
}
export enum API_CONTACT_CONTACTTYPE {
    PUBLIC = 'PUBLIC',
    PRIVATE = 'PRIVATE',
    CFT = 'CFT',
}
export enum API_CONTACTS_CONTACTTYPE {
    PUBLIC = 'PUBLIC',
    PRIVATE = 'PRIVATE',
    CFT = 'CFT',
}
export enum API_DELEGATE_TYPE {
    GROUP = 'GROUP',
    USER = 'USER',
}
export enum API_DELETEPROJECT_PROJECTSTATUS {
    ARCHIVE = 'ARCHIVE',
    DEACTIVATE = 'DEACTIVATE',
}
export enum API_DOCLISTFILTER_SORTBY {
    NAME = 'NAME',
    DESCRIPTION = 'DESCRIPTION',
    INDEX = 'INDEX',
    TYPE = 'TYPE',
    CREATED = 'CREATED',
    SIZE = 'SIZE',
    DIRECTORY = 'DIRECTORY',
    ID = 'ID',
    RELATION = 'RELATION',
    LAST_CHANGE = 'LAST_CHANGE',
    OWNER = 'OWNER',
    RELEVANCE = 'RELEVANCE',
}
export enum API_DOCLISTFILTER_SORTORDER {
    ASC = 'ASC',
    DESC = 'DESC',
}
export enum API_DOCUMENTFILE_OBJECTTYPE {
    MEETINGS = 'MEETINGS',
}
export enum API_DOCUMENTFILEUPLOADREQUESTDOCUMENTACTION_ACTION {
    CANCEL = 'CANCEL',
    RENAME = 'RENAME',
    REPLACE = 'REPLACE',
}
export enum API_DOCUMENTFILEUPLOADREQUESTDOCUMENTCONFLICT_CONFLICT {
    DOCUMENT_NAME_TAKEN = 'DOCUMENT_NAME_TAKEN',
    DOCUMENT_HASH_EXISTS = 'DOCUMENT_HASH_EXISTS',
}
export enum API_DOCUMENTFILTER_MINIMUMACCESSLEVEL {
    VIEW = 'VIEW',
    VIEW_WATERMARKED = 'VIEW_WATERMARKED',
    READONLY = 'READONLY',
    WRITE = 'WRITE',
    OWNER_FILES = 'OWNER_FILES',
    OWNER_FILES_AND_FOLDERS = 'OWNER_FILES_AND_FOLDERS',
}
export enum API_DOCUMENTS_MINACCESSLEVEL {
    VIEW = 'VIEW',
    VIEW_WATERMARKED = 'VIEW_WATERMARKED',
    READONLY = 'READONLY',
    WRITE = 'WRITE',
    OWNER_FILES = 'OWNER_FILES',
    OWNER_FILES_AND_FOLDERS = 'OWNER_FILES_AND_FOLDERS',
}
export enum API_DOCUMENTS_SORTBY {
    NAME = 'NAME',
    DESCRIPTION = 'DESCRIPTION',
    INDEX = 'INDEX',
    TYPE = 'TYPE',
    CREATED = 'CREATED',
    SIZE = 'SIZE',
    DIRECTORY = 'DIRECTORY',
    ID = 'ID',
    RELATION = 'RELATION',
    LAST_CHANGE = 'LAST_CHANGE',
    OWNER = 'OWNER',
    RELEVANCE = 'RELEVANCE',
}
export enum API_DOCUMENTS_SORTORDER {
    ASC = 'ASC',
    DESC = 'DESC',
}
export enum API_DOCUMENTSORTING_SORTBY {
    NAME = 'NAME',
    DESCRIPTION = 'DESCRIPTION',
    INDEX = 'INDEX',
    TYPE = 'TYPE',
    CREATED = 'CREATED',
    SIZE = 'SIZE',
    DIRECTORY = 'DIRECTORY',
    ID = 'ID',
    RELATION = 'RELATION',
    LAST_CHANGE = 'LAST_CHANGE',
    OWNER = 'OWNER',
    RELEVANCE = 'RELEVANCE',
}
export enum API_DOCUMENTSORTING_SORTORDER {
    ASC = 'ASC',
    DESC = 'DESC',
}
export enum API_DOWNLOADWIZARDREQUESTFILE_STATE {
    ACTIVE = 'ACTIVE',
    ARCHIVED = 'ARCHIVED',
    LOCKED = 'LOCKED',
    SYMLINK = 'SYMLINK',
    DELETED = 'DELETED',
    EXTERN_SYMLINK = 'EXTERN_SYMLINK',
}
export enum API_ELEMENTREST_ACCESS {
    HIDE = 'HIDE',
    READ = 'READ',
    WRITE = 'WRITE',
}
export enum API_ELEMENTREST_REPORTTYPE {
    WORKFLOWDETAILS = 'WorkflowDetails',
}
export enum API_ELEMENTREST_TYPE {
    HEADLINE = 'Headline',
    SELECTBOX = 'Selectbox',
    INPUT = 'Input',
    CURRENCYINPUT = 'CurrencyInput',
    INPUTBOX = 'Inputbox',
    TEXT = 'Text',
    CHECKBOX = 'Checkbox',
    DIRSELECT = 'DirSelect',
    SYSSELECT = 'SysSelect',
    BERICHT = 'Bericht',
    WERTETABELLE = 'Wertetabelle',
    DATE = 'Date',
    ERROR = 'Error',
    INFORMATION = 'Information',
    TABLE = 'Table',
}
export enum API_ENVIRONMENTTHEMEDATA_THEME {
    DEFAULT = 'DEFAULT',
    DYVE = 'DYVE',
    PAVE = 'PAVE',
    DOCNODES = 'DOCNODES',
}
export enum API_EXTERNALLINKED_STATE {
    ACTIVE = 'ACTIVE',
    ARCHIVED = 'ARCHIVED',
    LOCKED = 'LOCKED',
    SYMLINK = 'SYMLINK',
    DELETED = 'DELETED',
    EXTERN_SYMLINK = 'EXTERN_SYMLINK',
}
export enum API_EXTERNALLINKEDFOLDER_FOLDERACCESS {
    LIMITED = 'LIMITED',
    DENIED = 'DENIED',
}
export enum API_FEATUREFLAG_LIFECYCLESTATE {
    PILOT = 'PILOT',
    ACTIVE = 'ACTIVE',
    DEPRECATED = 'DEPRECATED',
    BLOCKED = 'BLOCKED',
    REMOVED = 'REMOVED',
}
export enum API_FEATUREFLAGASSIGNMENT_SCOPETYPE {
    ENV = 'ENV',
    PROJECT_GROUP = 'PROJECT_GROUP',
    PROJECT = 'PROJECT',
    USER = 'USER',
}
export enum API_FEATUREFLAGASSIGNMENTREQUEST_SCOPETYPE {
    ENV = 'ENV',
    PROJECT_GROUP = 'PROJECT_GROUP',
    PROJECT = 'PROJECT',
    USER = 'USER',
}
export enum API_FEATUREFLAGAUDIT_ACTION {
    CREATE_FLAG = 'CREATE_FLAG',
    UPDATE_FLAG = 'UPDATE_FLAG',
    CREATE_ASSIGNMENT = 'CREATE_ASSIGNMENT',
    UPDATE_ASSIGNMENT = 'UPDATE_ASSIGNMENT',
    DELETE_ASSIGNMENT = 'DELETE_ASSIGNMENT',
}
export enum API_FEATUREFLAGEVALUATIONDTO_SOURCE {
    BLOCKED = 'BLOCKED',
    USER = 'USER',
    PROJECT = 'PROJECT',
    PROJECT_GROUP = 'PROJECT_GROUP',
    ENVIRONMENT = 'ENVIRONMENT',
    DEFAULT = 'DEFAULT',
    ERROR = 'ERROR',
}
export enum API_FEATUREFLAGREQUEST_LIFECYCLESTATE {
    PILOT = 'PILOT',
    ACTIVE = 'ACTIVE',
    DEPRECATED = 'DEPRECATED',
    BLOCKED = 'BLOCKED',
    REMOVED = 'REMOVED',
}
export enum API_FILEATTACHMENT_ACCESSLEVEL {
    VIEW_ONLY = 'VIEW_ONLY',
    DOWNLOAD_WITH_WATERMARK = 'DOWNLOAD_WITH_WATERMARK',
    DOWNLOAD = 'DOWNLOAD',
}
export enum API_FILEDATAENTITY_RELATIONS {
    MASTER = 'MASTER',
    SLAVE = 'SLAVE',
    SYMLINK = 'SYMLINK',
    ORIGINAL = 'ORIGINAL',
    TASK = 'TASK',
    WORKFLOW = 'WORKFLOW',
    QUESTION = 'QUESTION',
}
export enum API_FILEDATAENTITY_STATE {
    ACTIVE = 'ACTIVE',
    ARCHIVED = 'ARCHIVED',
    LOCKED = 'LOCKED',
    SYMLINK = 'SYMLINK',
    DELETED = 'DELETED',
    EXTERN_SYMLINK = 'EXTERN_SYMLINK',
}
export enum API_FILEERRORINFORMATION_EXCEPTIONS {
    FILE_NAME = 'FILE_NAME',
    METADATA = 'METADATA',
    EXIST_LOCKED = 'EXIST_LOCKED',
    EXISTS = 'EXISTS',
    INDEX = 'INDEX',
    PDF_MISSING_FOR_DWG = 'PDF_MISSING_FOR_DWG',
}
export enum API_FILEINFO_FILEART {
    ALL = 'ALL',
    DEFAULT = 'DEFAULT',
    PLAN = 'PLAN',
    NOTE = 'NOTE',
    MASTER = 'MASTER',
    DOCUMENT = 'DOCUMENT',
    SYSTEM = 'SYSTEM',
    MODEL = 'MODEL',
    OTHER = 'OTHER',
}
export enum API_FILEINFO_FILESTATE {
    ACTIVE = 'ACTIVE',
    ARCHIVED = 'ARCHIVED',
}
export enum API_FILELISTREST_ACCESS {
    HIDE = 'HIDE',
    READ = 'READ',
    WRITE = 'WRITE',
    WRITEOWN = 'WRITEOWN',
}
export enum API_FILELISTREST_FILESOURCE {
    ALL_FILES = 'ALL_FILES',
    ONLY_UPLOAD = 'ONLY_UPLOAD',
    ONLY_PROJECT = 'ONLY_PROJECT',
}
export enum API_FILENAMEASSISTANTCONVENTIONRESPONSE_FORMAT {
    STRING = 'STRING',
    NUMMER = 'NUMMER',
    DATUM = 'DATUM',
    PATTERN = 'PATTERN',
    USEMETADATA = 'USEMETADATA',
}
export enum API_FILENAMEASSISTANTFILENAMERESPONSE_ERRORTYPE {
    OK = 'OK',
    FILENAME = 'FILENAME',
    BLOCK_NUM = 'BLOCK_NUM',
    FILETYPE = 'FILETYPE',
    VIEW_NO_AUTOMAPPING = 'VIEW_NO_AUTOMAPPING',
}
export enum API_FILENAMEASSISTANTFILENAMERESPONSE_FORMAT {
    BLOCK = 'BLOCK',
    POSITION = 'POSITION',
    INVALID = 'INVALID',
}
export enum API_FILENAMEASSISTANTRULERESPONSE_FORMAT {
    BLOCK = 'BLOCK',
    POSITION = 'POSITION',
    INVALID = 'INVALID',
}
export enum API_FILENAMEASSISTANTRULERESPONSE_INDEXREGEL {
    GREATER = 'GREATER',
    GREATER_EQUAL = 'GREATER_EQUAL',
    NOT_DEFINED = 'NOT_DEFINED',
}
export enum API_FILEREQUEST_STATE {
    ACTIVE = 'ACTIVE',
    ARCHIVED = 'ARCHIVED',
    LOCKED = 'LOCKED',
    SYMLINK = 'SYMLINK',
    DELETED = 'DELETED',
    EXTERN_SYMLINK = 'EXTERN_SYMLINK',
}
export enum API_FILES_MODULE {
    MAIL = 'MAIL',
    DOCUMENTS = 'DOCUMENTS',
    VIEW = 'VIEW',
    QA = 'QA',
    BIM = 'BIM',
    TASKS = 'TASKS',
    WORKFLOW = 'WORKFLOW',
    TENDER_MODERN = 'TENDER_MODERN',
    TENDER = 'TENDER',
    LOP = 'LOP',
    CALENDAR = 'CALENDAR',
    OX_MODULES = 'OX_MODULES',
    CONSTRUCTIONLOG = 'CONSTRUCTIONLOG',
    ONLINEBAUABNAHME = 'ONLINEBAUABNAHME',
    OX_FOTOS = 'OX_FOTOS',
    OX_CHECKLISTS = 'OX_CHECKLISTS',
    CLAIMDOC = 'CLAIMDOC',
    WEBCAM = 'WEBCAM',
    EAKTE = 'EAKTE',
    CONTRACTMANAGEMENT = 'CONTRACTMANAGEMENT',
    PROTOCOLLMANAGEMENT = 'PROTOCOLLMANAGEMENT',
    RESOLUTIONS = 'RESOLUTIONS',
    ORGANIZATIONS = 'ORGANIZATIONS',
    CLAIM_COCKPIT = 'CLAIM_COCKPIT',
    INVESTIGATIONS = 'INVESTIGATIONS',
    PLAN_DELIVERY_LIST = 'PLAN_DELIVERY_LIST',
    VALUE_TABLE = 'VALUE_TABLE',
    PROJECT_MANAGMENT = 'PROJECT_MANAGMENT',
    BIM_ISSUES = 'BIM_ISSUES',
    DOCUMENTS_AND_PLANS = 'DOCUMENTS_AND_PLANS',
    KPI_DASHBOARD = 'KPI_DASHBOARD',
    STA_INTEGRATION = 'STA_INTEGRATION',
}
export enum API_FILESHARINGSETTINGS_ACCESSLEVEL {
    VIEW_ONLY = 'VIEW_ONLY',
    DOWNLOAD_WITH_WATERMARK = 'DOWNLOAD_WITH_WATERMARK',
    DOWNLOAD = 'DOWNLOAD',
}
export enum API_FOLDERCOPYRESPONSE_STATUS {
    OK = 'OK',
    NO_ACCESS = 'NO_ACCESS',
    NO_SYMLINK_ACCESS = 'NO_SYMLINK_ACCESS',
    CONTAINS_EXTERNAL_SYMLINKS = 'CONTAINS_EXTERNAL_SYMLINKS',
}
export enum API_FOLDERDATAENTITY_FOLDERACCESS {
    LIMITED = 'LIMITED',
    DENIED = 'DENIED',
}
export enum API_FOLDERDATAENTITY_STATE {
    ACTIVE = 'ACTIVE',
    ARCHIVED = 'ARCHIVED',
    LOCKED = 'LOCKED',
    SYMLINK = 'SYMLINK',
    DELETED = 'DELETED',
    EXTERN_SYMLINK = 'EXTERN_SYMLINK',
}
export enum API_FOLDERDATAENTITY_TYPE {
    FOLDER = 'FOLDER',
}
export enum API_FOLDERRIGHTSENTRY_ACCESSLEVEL {
    VIEW = 'VIEW',
    VIEW_WATERMARKED = 'VIEW_WATERMARKED',
    READONLY = 'READONLY',
    WRITE = 'WRITE',
    OWNER_FILES = 'OWNER_FILES',
    OWNER_FILES_AND_FOLDERS = 'OWNER_FILES_AND_FOLDERS',
}
export enum API_FOLDERS_MINACCESSLEVEL {
    VIEW = 'VIEW',
    VIEW_WATERMARKED = 'VIEW_WATERMARKED',
    READONLY = 'READONLY',
    WRITE = 'WRITE',
    OWNER_FILES = 'OWNER_FILES',
    OWNER_FILES_AND_FOLDERS = 'OWNER_FILES_AND_FOLDERS',
}
export enum API_GENERALSETTINGS_READACCESSTORIGHTS {
    VIEW = 'VIEW',
    VIEW_WATERMARKED = 'VIEW_WATERMARKED',
    READONLY = 'READONLY',
    WRITE = 'WRITE',
    OWNER_FILES = 'OWNER_FILES',
    OWNER_FILES_AND_FOLDERS = 'OWNER_FILES_AND_FOLDERS',
}
export enum API_GROUP_TYPE {
    PUBLIC = 'PUBLIC',
    PRIVATE = 'PRIVATE',
    ORGANISATION = 'ORGANISATION',
    SYSTEM = 'SYSTEM',
}
export enum API_GROUPMEMBER_LASTENVIRONMENT {
    NONE = 'NONE',
    CLASSIC = 'CLASSIC',
    MODERN = 'MODERN',
}
export enum API_GROUPMEMBER_MEMBERTYPE {
    PROJECT_MEMBER = 'PROJECT_MEMBER',
    GLOBAL_CONTACT = 'GLOBAL_CONTACT',
    PRIVATE_CONTACT = 'PRIVATE_CONTACT',
}
export enum API_GROUPMEMBERASSIGN_MEMBERTYPE {
    PROJECT_MEMBER = 'PROJECT_MEMBER',
    GLOBAL_CONTACT = 'GLOBAL_CONTACT',
    PRIVATE_CONTACT = 'PRIVATE_CONTACT',
}
export enum API_GROUPPOOL_ACCESSLEVEL {
    FULL = 'FULL',
    READONLY = 'READONLY',
    DENIED = 'DENIED',
}
export enum API_GROUPPOOL_ROLE {
    SUPPLIER_MANAGER = 'SUPPLIER_MANAGER',
    CALL_MANAGER = 'CALL_MANAGER',
    REVIEWER = 'REVIEWER',
    INSPECTOR = 'INSPECTOR',
    EVALUATOR = 'EVALUATOR',
    READ_ALL_CALLS = 'READ_ALL_CALLS',
    MAIL_TEMPLATES = 'MAIL_TEMPLATES',
    BIDDER = 'BIDDER',
}
export enum API_GROUPS_SORTBY {
    USER = 'USER',
    COMPANY = 'COMPANY',
}
export enum API_GROUPS_SORTORDER {
    ASC = 'ASC',
    DESC = 'DESC',
}
export enum API_KPIBCFFILTER_AUTHOR {
    CREATED_BY_ME = 'CREATED_BY_ME',
    ASSIGNED_TO_ME = 'ASSIGNED_TO_ME',
    ALL = 'ALL',
}
export enum API_KPIDEFINITION_CHARTTYPE {
    LINE_CHART = 'LINE_CHART',
    BAR_CHART = 'BAR_CHART',
    AREA_CHART = 'AREA_CHART',
    PIE_CHART = 'PIE_CHART',
    TABLE = 'TABLE',
    INTRO = 'INTRO',
}
export enum API_KPIDEFINITION_MODULETYPE {
    LOP = 'LOP',
    WORKFLOWS = 'WORKFLOWS',
    TASKS = 'TASKS',
    BCF_SERVER = 'BCF_SERVER',
    INTRO = 'INTRO',
}
export enum API_KPIFILTER_ASSIGNEE {
    CREATED_BY_ME = 'CREATED_BY_ME',
    ASSIGNED_TO_ME = 'ASSIGNED_TO_ME',
    ALL = 'ALL',
}
export enum API_KPIFILTER_PERIOD {
    LAST_WEEK = 'LAST_WEEK',
    LAST_MONTH = 'LAST_MONTH',
    LAST_3_MONTHS = 'LAST_3_MONTHS',
    ALL = 'ALL',
}
export enum API_KPIFILTER_PRIORITY {
    LOW = 'LOW',
    NORMAL = 'NORMAL',
    HIGH = 'HIGH',
    ALL = 'ALL',
}
export enum API_KPIFILTER_STATUS {
    STARTED = 'STARTED',
    FINISHED = 'FINISHED',
    ABORTED = 'ABORTED',
    ERROR = 'ERROR',
    OPEN = 'OPEN',
    IN_PROGRESS = 'IN_PROGRESS',
    WAITING = 'WAITING',
    CANCELED = 'CANCELED',
    OVERDUE = 'OVERDUE',
    REOPENED = 'REOPENED',
    CLOSED = 'CLOSED',
}
export enum API_KPIWORKFLOWFILTER_RESULT {
    DATEISTATUS_ENTWURF = 'DATEISTATUS_ENTWURF',
    DATEISTATUS_FREIGEGEBEN = 'DATEISTATUS_FREIGEGEBEN',
    DATEISTATUS_INVORBEREITUNG = 'DATEISTATUS_INVORBEREITUNG',
    DATEISTATUS_ZURFREIGEGEBEN = 'DATEISTATUS_ZURFREIGEGEBEN',
    DATEISTATUS_ABGENOMMEN = 'DATEISTATUS_ABGENOMMEN',
    DATEISTATUS_ABGELEHNT = 'DATEISTATUS_ABGELEHNT',
    DATEISTATUS_INPRUEFUNG = 'DATEISTATUS_INPRUEFUNG',
    DATEISTATUS_FREIGEGEBEN_OHNE_KOMMENTAR = 'DATEISTATUS_FREIGEGEBEN_OHNE_KOMMENTAR',
    DATEISTATUS_FREIGEGEBEN_MIT_KOMMENTAREN = 'DATEISTATUS_FREIGEGEBEN_MIT_KOMMENTAREN',
    DATEISTATUS_TEILFREIGABE_MIT_KOMMENTAREN = 'DATEISTATUS_TEILFREIGABE_MIT_KOMMENTAREN',
    DATEISTATUS_ZURUECKGEWIESEN = 'DATEISTATUS_ZURUECKGEWIESEN',
    ALL = 'ALL',
}
export enum API_LINKED_SORTBY {
    NAME = 'NAME',
    DESCRIPTION = 'DESCRIPTION',
    INDEX = 'INDEX',
    TYPE = 'TYPE',
    CREATED = 'CREATED',
    SIZE = 'SIZE',
    DIRECTORY = 'DIRECTORY',
    ID = 'ID',
    RELATION = 'RELATION',
    LAST_CHANGE = 'LAST_CHANGE',
    OWNER = 'OWNER',
    RELEVANCE = 'RELEVANCE',
}
export enum API_LINKED_SORTORDER {
    ASC = 'ASC',
    DESC = 'DESC',
}
export enum API_LINKEDUSERDETAILS_MAILSIGNATUREOPTION {
    NONE = 'NONE',
    UNIFIED = 'UNIFIED',
    CUSTOM = 'CUSTOM',
}
export enum API_LINKTOKEN_TYPE {
    TYPE_WEBDAV_BROWSER_LINK = 'TYPE_WEBDAV_BROWSER_LINK',
}
export enum API_LOCKEDACCESS_TYPE {
    USER = 'USER',
    PAVE_USER = 'PAVE_USER',
    IP = 'IP',
    MAIL = 'MAIL',
    BIDDER = 'BIDDER',
}
export enum API_LOGDATA_OBJECTTYPE {
    UNKNOWN = 'UNKNOWN',
    FILE = 'FILE',
    DIRECTORY = 'DIRECTORY',
    USER = 'USER',
    PR_GROUP = 'PR_GROUP',
    GROUP = 'GROUP',
    PDL = 'PDL',
    PDL_PACKAGE = 'PDL_PACKAGE',
    PDL_ITEM = 'PDL_ITEM',
    PDL_ITEM_FILE = 'PDL_ITEM_FILE',
    PDL_ACL = 'PDL_ACL',
    PDL_ADMIN = 'PDL_ADMIN',
    METADATA = 'METADATA',
    FILE_ARCHIVE = 'FILE_ARCHIVE',
    FILE_SYMLINK = 'FILE_SYMLINK',
    PROJECT_SETTINGS = 'PROJECT_SETTINGS',
    PROJECT_INFO = 'PROJECT_INFO',
    ADMIN_PROJECT_SETTINGS = 'ADMIN_PROJECT_SETTINGS',
    USER_SETTINGS = 'USER_SETTINGS',
    PRINT_JOBS_SETTINGS = 'PRINT_JOBS_SETTINGS',
    QA_SETTINGS = 'QA_SETTINGS',
    QA_CATEGORY = 'QA_CATEGORY',
    DIRECTORY_SYMLINK = 'DIRECTORY_SYMLINK',
    QA_QUESTION = 'QA_QUESTION',
    QA_ANSWER = 'QA_ANSWER',
    QA_TIMER = 'QA_TIMER',
    COMMENT = 'COMMENT',
}
export enum API_LOGDATA_OPERATIONTYPE {
    CREATE = 'CREATE',
    READ = 'READ',
    UPDATE = 'UPDATE',
    DELETE = 'DELETE',
    RESTORE = 'RESTORE',
}
export enum API_LOGININFORMATION_REDIRECTMODULE {
    MAIL = 'MAIL',
    DOCUMENTS = 'DOCUMENTS',
    VIEW = 'VIEW',
    QA = 'QA',
    BIM = 'BIM',
    TASKS = 'TASKS',
    WORKFLOW = 'WORKFLOW',
    TENDER_MODERN = 'TENDER_MODERN',
    TENDER = 'TENDER',
    LOP = 'LOP',
    CALENDAR = 'CALENDAR',
    OX_MODULES = 'OX_MODULES',
    CONSTRUCTIONLOG = 'CONSTRUCTIONLOG',
    ONLINEBAUABNAHME = 'ONLINEBAUABNAHME',
    OX_FOTOS = 'OX_FOTOS',
    OX_CHECKLISTS = 'OX_CHECKLISTS',
    CLAIMDOC = 'CLAIMDOC',
    WEBCAM = 'WEBCAM',
    EAKTE = 'EAKTE',
    CONTRACTMANAGEMENT = 'CONTRACTMANAGEMENT',
    PROTOCOLLMANAGEMENT = 'PROTOCOLLMANAGEMENT',
    RESOLUTIONS = 'RESOLUTIONS',
    ORGANIZATIONS = 'ORGANIZATIONS',
    CLAIM_COCKPIT = 'CLAIM_COCKPIT',
    INVESTIGATIONS = 'INVESTIGATIONS',
    PLAN_DELIVERY_LIST = 'PLAN_DELIVERY_LIST',
    VALUE_TABLE = 'VALUE_TABLE',
    PROJECT_MANAGMENT = 'PROJECT_MANAGMENT',
    BIM_ISSUES = 'BIM_ISSUES',
    DOCUMENTS_AND_PLANS = 'DOCUMENTS_AND_PLANS',
    KPI_DASHBOARD = 'KPI_DASHBOARD',
    STA_INTEGRATION = 'STA_INTEGRATION',
}
export enum API_LOGININFORMATION_ROLE {
    UNKNOWN = 'UNKNOWN',
    GUEST = 'GUEST',
    USER = 'USER',
    PRGROUPADMIN = 'PRGROUPADMIN',
    ADMIN = 'ADMIN',
    BIDDER = 'BIDDER',
}
export enum API_LOGININFORMATION_STATUS {
    OK = 'OK',
    CHANGE_PASSWORD = 'CHANGE_PASSWORD',
    SECOND_TOKEN_NEEDED = 'SECOND_TOKEN_NEEDED',
    SECOND_TOKEN_UNINITIALIZED = 'SECOND_TOKEN_UNINITIALIZED',
    MCP_WRITE_CONSENT = 'MCP_WRITE_CONSENT',
}
export enum API_LOGININFORMATION_TOKENTYPE {
    STANDARD = 'STANDARD',
    TOTP = 'TOTP',
    SMS = 'SMS',
    WEBDAV = 'WEBDAV',
    EMAIL = 'EMAIL',
    FIDO = 'FIDO',
}
export enum API_LOGINSETTINGS_AVAILABLELOGINS {
    DEFAULT = 'Default',
}
export enum API_LOGINSETTINGS_THEME {
    DEFAULT = 'DEFAULT',
    DYVE = 'DYVE',
    PAVE = 'PAVE',
    DOCNODES = 'DOCNODES',
}
export enum API_LOP_STATUS {
    OPEN = 'OPEN',
    IN_PROGRESS = 'IN_PROGRESS',
    WAITING = 'WAITING',
    FINISHED = 'FINISHED',
    CANCELED = 'CANCELED',
}
export enum API_LOPACL_LISTRIGHT {
    READ = 'READ',
    WRITE = 'WRITE',
    OWNER = 'OWNER',
}
export enum API_LOPACL_SUBJECTTYPE {
    USER = 'USER',
    GROUP = 'GROUP',
}
export enum API_LOPINFO_OP_STATUS {
    OPEN = 'OPEN',
    IN_PROGRESS = 'IN_PROGRESS',
    WAITING = 'WAITING',
    FINISHED = 'FINISHED',
    CANCELED = 'CANCELED',
}
export enum API_LOPINFO_RIGHT {
    READ = 'READ',
    WRITE = 'WRITE',
    OWNER = 'OWNER',
}
export enum API_LOPINFO_STATUS {
    OPEN = 'OPEN',
    IN_PROGRESS = 'IN_PROGRESS',
    WAITING = 'WAITING',
    FINISHED = 'FINISHED',
    CANCELED = 'CANCELED',
}
export enum API_LOPOPENPOINT_CHANGEDTASKFIELDS {
    NAME = 'name',
    DESCRIPTION = 'description',
    STARTDATE = 'startDate',
    DUEDATE = 'dueDate',
    PRIORITY = 'priority',
    STATE = 'state',
    RESPONSIBLEUSER = 'responsibleUser',
}
export enum API_LOPOPENPOINT_PRIORITY {
    LOW = 'LOW',
    NORMAL = 'NORMAL',
    HIGH = 'HIGH',
}
export enum API_LOPOPENPOINT_STATUS {
    OPEN = 'OPEN',
    IN_PROGRESS = 'IN_PROGRESS',
    WAITING = 'WAITING',
    FINISHED = 'FINISHED',
    CANCELED = 'CANCELED',
}
export enum API_MAILINBOXFILTER_FILTERTYPE {
    SENDER = 'SENDER',
    SUBJECT = 'SUBJECT',
    ATTACHMENT_EXISTS = 'ATTACHMENT_EXISTS',
    ATTACHMENT_CONTAINS = 'ATTACHMENT_CONTAINS',
    ATTACHMENT_FULFILLS_CONVENTION = 'ATTACHMENT_FULFILLS_CONVENTION',
}
export enum API_MAILMODULESETTINGS_PROJECTINBOX {
    VIEW = 'VIEW',
    VIEW_WATERMARKED = 'VIEW_WATERMARKED',
    READONLY = 'READONLY',
    WRITE = 'WRITE',
    OWNER_FILES = 'OWNER_FILES',
    OWNER_FILES_AND_FOLDERS = 'OWNER_FILES_AND_FOLDERS',
}
export enum API_MAILPAGINATION_SORTBY {
    ATTACHMENT = 'ATTACHMENT',
    DATE = 'DATE',
    NAME = 'NAME',
    IMPORTANCE = 'IMPORTANCE',
    SUBJECT = 'SUBJECT',
}
export enum API_MAILPAGINATION_SORTORDER {
    ASC = 'ASC',
    DESC = 'DESC',
}
export enum API_MAILREQUEST_ATTACHMENTTYPE {
    LINK = 'LINK',
    FILE = 'FILE',
}
export enum API_MAILREQUEST_CAUSE {
    AUTOINFO = 'AUTOINFO',
    DISTRIBUTION_MATRIX = 'DISTRIBUTION_MATRIX',
    BATCH_FILE_REPORT = 'BATCH_FILE_REPORT',
    INDIVIDUAL = 'INDIVIDUAL',
}
export enum API_MAILREQUEST_IMPORTANCE {
    NORMAL = 'NORMAL',
    LOW = 'LOW',
    HIGH = 'HIGH',
}
export enum API_MAILREQUEST_PREVIOUSTYPE {
    INBOX = 'INBOX',
    SENT = 'SENT',
    ARCHIVED = 'ARCHIVED',
    LINKED = 'LINKED',
    DELETED = 'DELETED',
    DRAFT = 'DRAFT',
}
export enum API_MAILREQUEST_TYPE {
    INBOX = 'INBOX',
    SENT = 'SENT',
    ARCHIVED = 'ARCHIVED',
    LINKED = 'LINKED',
    DELETED = 'DELETED',
    DRAFT = 'DRAFT',
}
export enum API_MAILRESPONSE_IMPORTANCE {
    NORMAL = 'NORMAL',
    LOW = 'LOW',
    HIGH = 'HIGH',
}
export enum API_MAILRESPONSE_PREVIOUSTYPE {
    INBOX = 'INBOX',
    SENT = 'SENT',
    ARCHIVED = 'ARCHIVED',
    LINKED = 'LINKED',
    DELETED = 'DELETED',
    DRAFT = 'DRAFT',
}
export enum API_MAILRESPONSE_TYPE {
    INBOX = 'INBOX',
    SENT = 'SENT',
    ARCHIVED = 'ARCHIVED',
    LINKED = 'LINKED',
    DELETED = 'DELETED',
    DRAFT = 'DRAFT',
}
export enum API_MAILS_SORTBY {
    ATTACHMENT = 'ATTACHMENT',
    DATE = 'DATE',
    NAME = 'NAME',
    IMPORTANCE = 'IMPORTANCE',
    SUBJECT = 'SUBJECT',
}
export enum API_MAILS_SORTORDER {
    ASC = 'ASC',
    DESC = 'DESC',
}
export enum API_MAILS_TYPE {
    INBOX = 'INBOX',
    SENT = 'SENT',
    ARCHIVED = 'ARCHIVED',
    LINKED = 'LINKED',
    DELETED = 'DELETED',
    DRAFT = 'DRAFT',
}
export enum API_MEETINGACCESS_MEETINGACCESS {
    READ = 'READ',
    WRITE = 'WRITE',
    OWNER = 'OWNER',
}
export enum API_MEETINGACCESS_SERIESACCESS {
    READ = 'READ',
    WRITE = 'WRITE',
    OWNER = 'OWNER',
}
export enum API_MEETINGACCESSENTRY_LEVEL {
    READ = 'READ',
    WRITE = 'WRITE',
    OWNER = 'OWNER',
}
export enum API_MEETINGACCESSUSERRIGHT_RIGHT {
    READ = 'READ',
    WRITE = 'WRITE',
    OWNER = 'OWNER',
}
export enum API_MEETINGAGENDAITEM_STATUS {
    OPEN = 'OPEN',
    IN_PROGRESS = 'IN_PROGRESS',
    WAITING = 'WAITING',
    DONE = 'DONE',
    CANCELLED = 'CANCELLED',
}
export enum API_MEETINGAGENDAITEM_TYPE {
    INFO = 'INFO',
    TASK = 'TASK',
    RESOLUTION = 'RESOLUTION',
}
export enum API_MEETINGITEM_STATUS {
    OPEN = 'OPEN',
    IN_PROGRESS = 'IN_PROGRESS',
    FINALIZED = 'FINALIZED',
    FINALIZED_EDITED = 'FINALIZED_EDITED',
    CANCELLED = 'CANCELLED',
}
export enum API_MESSAGETEMPLATE_PURPOSE {
    BIDDER_INVITATION = 'BIDDER_INVITATION',
    REVIEW_START = 'REVIEW_START',
    INSPECTION_START = 'INSPECTION_START',
    EVALUATION_START = 'EVALUATION_START',
    BIDDER_NEGATIVE_REPLY = 'BIDDER_NEGATIVE_REPLY',
    CFT_CHANGED_DETAILS = 'CFT_CHANGED_DETAILS',
    CFT_CHANGED_BIDDING_END = 'CFT_CHANGED_BIDDING_END',
    REMINDER = 'REMINDER',
    RESEND_ACCESS = 'RESEND_ACCESS',
    BIDDER_DEACTIVATED = 'BIDDER_DEACTIVATED',
}
export enum API_MESSAGETEMPLATES_PURPOSE {
    BIDDER_INVITATION = 'BIDDER_INVITATION',
    REVIEW_START = 'REVIEW_START',
    INSPECTION_START = 'INSPECTION_START',
    EVALUATION_START = 'EVALUATION_START',
    BIDDER_NEGATIVE_REPLY = 'BIDDER_NEGATIVE_REPLY',
    CFT_CHANGED_DETAILS = 'CFT_CHANGED_DETAILS',
    CFT_CHANGED_BIDDING_END = 'CFT_CHANGED_BIDDING_END',
    REMINDER = 'REMINDER',
    RESEND_ACCESS = 'RESEND_ACCESS',
    BIDDER_DEACTIVATED = 'BIDDER_DEACTIVATED',
}
export enum API_MODULEDATA_MODULE {
    MAIL = 'MAIL',
    DOCUMENTS = 'DOCUMENTS',
    VIEW = 'VIEW',
    QA = 'QA',
    BIM = 'BIM',
    TASKS = 'TASKS',
    WORKFLOW = 'WORKFLOW',
    TENDER_MODERN = 'TENDER_MODERN',
    TENDER = 'TENDER',
    LOP = 'LOP',
    CALENDAR = 'CALENDAR',
    OX_MODULES = 'OX_MODULES',
    CONSTRUCTIONLOG = 'CONSTRUCTIONLOG',
    ONLINEBAUABNAHME = 'ONLINEBAUABNAHME',
    OX_FOTOS = 'OX_FOTOS',
    OX_CHECKLISTS = 'OX_CHECKLISTS',
    CLAIMDOC = 'CLAIMDOC',
    WEBCAM = 'WEBCAM',
    EAKTE = 'EAKTE',
    CONTRACTMANAGEMENT = 'CONTRACTMANAGEMENT',
    PROTOCOLLMANAGEMENT = 'PROTOCOLLMANAGEMENT',
    RESOLUTIONS = 'RESOLUTIONS',
    ORGANIZATIONS = 'ORGANIZATIONS',
    CLAIM_COCKPIT = 'CLAIM_COCKPIT',
    INVESTIGATIONS = 'INVESTIGATIONS',
    PLAN_DELIVERY_LIST = 'PLAN_DELIVERY_LIST',
    VALUE_TABLE = 'VALUE_TABLE',
    PROJECT_MANAGMENT = 'PROJECT_MANAGMENT',
    BIM_ISSUES = 'BIM_ISSUES',
    DOCUMENTS_AND_PLANS = 'DOCUMENTS_AND_PLANS',
    KPI_DASHBOARD = 'KPI_DASHBOARD',
    STA_INTEGRATION = 'STA_INTEGRATION',
}
export enum API_MODULEFILESSTATISTICS_MODULE {
    MAIL = 'MAIL',
    DOCUMENTS = 'DOCUMENTS',
    VIEW = 'VIEW',
    QA = 'QA',
    BIM = 'BIM',
    TASKS = 'TASKS',
    WORKFLOW = 'WORKFLOW',
    TENDER_MODERN = 'TENDER_MODERN',
    TENDER = 'TENDER',
    LOP = 'LOP',
    CALENDAR = 'CALENDAR',
    OX_MODULES = 'OX_MODULES',
    CONSTRUCTIONLOG = 'CONSTRUCTIONLOG',
    ONLINEBAUABNAHME = 'ONLINEBAUABNAHME',
    OX_FOTOS = 'OX_FOTOS',
    OX_CHECKLISTS = 'OX_CHECKLISTS',
    CLAIMDOC = 'CLAIMDOC',
    WEBCAM = 'WEBCAM',
    EAKTE = 'EAKTE',
    CONTRACTMANAGEMENT = 'CONTRACTMANAGEMENT',
    PROTOCOLLMANAGEMENT = 'PROTOCOLLMANAGEMENT',
    RESOLUTIONS = 'RESOLUTIONS',
    ORGANIZATIONS = 'ORGANIZATIONS',
    CLAIM_COCKPIT = 'CLAIM_COCKPIT',
    INVESTIGATIONS = 'INVESTIGATIONS',
    PLAN_DELIVERY_LIST = 'PLAN_DELIVERY_LIST',
    VALUE_TABLE = 'VALUE_TABLE',
    PROJECT_MANAGMENT = 'PROJECT_MANAGMENT',
    BIM_ISSUES = 'BIM_ISSUES',
    DOCUMENTS_AND_PLANS = 'DOCUMENTS_AND_PLANS',
    KPI_DASHBOARD = 'KPI_DASHBOARD',
    STA_INTEGRATION = 'STA_INTEGRATION',
}
export enum API_MOVEMAILINFO_MAILTYPE {
    INBOX = 'INBOX',
    SENT = 'SENT',
    ARCHIVED = 'ARCHIVED',
    LINKED = 'LINKED',
    DELETED = 'DELETED',
    DRAFT = 'DRAFT',
}
export enum API_MULTITENDERCALLRESPONSE_ACCESSIBLESTATUS {
    INITIALIZED = 'INITIALIZED',
    ABORTED = 'ABORTED',
    RUNNING = 'RUNNING',
    IN_REVIEW = 'IN_REVIEW',
    IN_INSPECTION = 'IN_INSPECTION',
    FINISHED = 'FINISHED',
}
export enum API_MULTITENDERCALLRESPONSE_ACCESSLEVEL {
    FULL = 'FULL',
    READONLY = 'READONLY',
    DENIED = 'DENIED',
}
export enum API_NEWCOOKIE_SAMESITE {
    NONE = 'NONE',
    LAX = 'LAX',
    STRICT = 'STRICT',
}
export enum API_NOTIFICATION_MODULE {
    MAIL = 'MAIL',
    DOCUMENTS = 'DOCUMENTS',
    VIEW = 'VIEW',
    QA = 'QA',
    BIM = 'BIM',
    TASKS = 'TASKS',
    WORKFLOW = 'WORKFLOW',
    TENDER_MODERN = 'TENDER_MODERN',
    TENDER = 'TENDER',
    LOP = 'LOP',
    CALENDAR = 'CALENDAR',
    OX_MODULES = 'OX_MODULES',
    CONSTRUCTIONLOG = 'CONSTRUCTIONLOG',
    ONLINEBAUABNAHME = 'ONLINEBAUABNAHME',
    OX_FOTOS = 'OX_FOTOS',
    OX_CHECKLISTS = 'OX_CHECKLISTS',
    CLAIMDOC = 'CLAIMDOC',
    WEBCAM = 'WEBCAM',
    EAKTE = 'EAKTE',
    CONTRACTMANAGEMENT = 'CONTRACTMANAGEMENT',
    PROTOCOLLMANAGEMENT = 'PROTOCOLLMANAGEMENT',
    RESOLUTIONS = 'RESOLUTIONS',
    ORGANIZATIONS = 'ORGANIZATIONS',
    CLAIM_COCKPIT = 'CLAIM_COCKPIT',
    INVESTIGATIONS = 'INVESTIGATIONS',
    PLAN_DELIVERY_LIST = 'PLAN_DELIVERY_LIST',
    VALUE_TABLE = 'VALUE_TABLE',
    PROJECT_MANAGMENT = 'PROJECT_MANAGMENT',
    BIM_ISSUES = 'BIM_ISSUES',
    DOCUMENTS_AND_PLANS = 'DOCUMENTS_AND_PLANS',
    KPI_DASHBOARD = 'KPI_DASHBOARD',
    STA_INTEGRATION = 'STA_INTEGRATION',
}
export enum API_OAUTH2SERVER_PROTOCOL {
    JSON = 'JSON',
    SAML = 'SAML',
    AAD = 'AAD',
}
export enum API_ORGANISATION_LIMITATION {
    NO_LIMIT = 'NO_LIMIT',
    DAILY = 'DAILY',
    WEEKLY = 'WEEKLY',
    MONTHLY = 'MONTHLY',
    TOTAL = 'TOTAL',
}
export enum API_OX_MODULE {
    MAIL = 'MAIL',
    DOCUMENTS = 'DOCUMENTS',
    VIEW = 'VIEW',
    QA = 'QA',
    BIM = 'BIM',
    TASKS = 'TASKS',
    WORKFLOW = 'WORKFLOW',
    TENDER_MODERN = 'TENDER_MODERN',
    TENDER = 'TENDER',
    LOP = 'LOP',
    CALENDAR = 'CALENDAR',
    OX_MODULES = 'OX_MODULES',
    CONSTRUCTIONLOG = 'CONSTRUCTIONLOG',
    ONLINEBAUABNAHME = 'ONLINEBAUABNAHME',
    OX_FOTOS = 'OX_FOTOS',
    OX_CHECKLISTS = 'OX_CHECKLISTS',
    CLAIMDOC = 'CLAIMDOC',
    WEBCAM = 'WEBCAM',
    EAKTE = 'EAKTE',
    CONTRACTMANAGEMENT = 'CONTRACTMANAGEMENT',
    PROTOCOLLMANAGEMENT = 'PROTOCOLLMANAGEMENT',
    RESOLUTIONS = 'RESOLUTIONS',
    ORGANIZATIONS = 'ORGANIZATIONS',
    CLAIM_COCKPIT = 'CLAIM_COCKPIT',
    INVESTIGATIONS = 'INVESTIGATIONS',
    PLAN_DELIVERY_LIST = 'PLAN_DELIVERY_LIST',
    VALUE_TABLE = 'VALUE_TABLE',
    PROJECT_MANAGMENT = 'PROJECT_MANAGMENT',
    BIM_ISSUES = 'BIM_ISSUES',
    DOCUMENTS_AND_PLANS = 'DOCUMENTS_AND_PLANS',
    KPI_DASHBOARD = 'KPI_DASHBOARD',
    STA_INTEGRATION = 'STA_INTEGRATION',
}
export enum API_OXCONNECTIONRESULT_MODULE {
    MAIL = 'MAIL',
    DOCUMENTS = 'DOCUMENTS',
    VIEW = 'VIEW',
    QA = 'QA',
    BIM = 'BIM',
    TASKS = 'TASKS',
    WORKFLOW = 'WORKFLOW',
    TENDER_MODERN = 'TENDER_MODERN',
    TENDER = 'TENDER',
    LOP = 'LOP',
    CALENDAR = 'CALENDAR',
    OX_MODULES = 'OX_MODULES',
    CONSTRUCTIONLOG = 'CONSTRUCTIONLOG',
    ONLINEBAUABNAHME = 'ONLINEBAUABNAHME',
    OX_FOTOS = 'OX_FOTOS',
    OX_CHECKLISTS = 'OX_CHECKLISTS',
    CLAIMDOC = 'CLAIMDOC',
    WEBCAM = 'WEBCAM',
    EAKTE = 'EAKTE',
    CONTRACTMANAGEMENT = 'CONTRACTMANAGEMENT',
    PROTOCOLLMANAGEMENT = 'PROTOCOLLMANAGEMENT',
    RESOLUTIONS = 'RESOLUTIONS',
    ORGANIZATIONS = 'ORGANIZATIONS',
    CLAIM_COCKPIT = 'CLAIM_COCKPIT',
    INVESTIGATIONS = 'INVESTIGATIONS',
    PLAN_DELIVERY_LIST = 'PLAN_DELIVERY_LIST',
    VALUE_TABLE = 'VALUE_TABLE',
    PROJECT_MANAGMENT = 'PROJECT_MANAGMENT',
    BIM_ISSUES = 'BIM_ISSUES',
    DOCUMENTS_AND_PLANS = 'DOCUMENTS_AND_PLANS',
    KPI_DASHBOARD = 'KPI_DASHBOARD',
    STA_INTEGRATION = 'STA_INTEGRATION',
}
export enum API_OXCONNECTIONRESULT_STATUS {
    NEW = 'NEW',
    CONFIGURATION_MISSING = 'CONFIGURATION_MISSING',
    ERROR = 'ERROR',
    CONNECTED = 'CONNECTED',
}
export enum API_OXMODULE_MODULE {
    MAIL = 'MAIL',
    DOCUMENTS = 'DOCUMENTS',
    VIEW = 'VIEW',
    QA = 'QA',
    BIM = 'BIM',
    TASKS = 'TASKS',
    WORKFLOW = 'WORKFLOW',
    TENDER_MODERN = 'TENDER_MODERN',
    TENDER = 'TENDER',
    LOP = 'LOP',
    CALENDAR = 'CALENDAR',
    OX_MODULES = 'OX_MODULES',
    CONSTRUCTIONLOG = 'CONSTRUCTIONLOG',
    ONLINEBAUABNAHME = 'ONLINEBAUABNAHME',
    OX_FOTOS = 'OX_FOTOS',
    OX_CHECKLISTS = 'OX_CHECKLISTS',
    CLAIMDOC = 'CLAIMDOC',
    WEBCAM = 'WEBCAM',
    EAKTE = 'EAKTE',
    CONTRACTMANAGEMENT = 'CONTRACTMANAGEMENT',
    PROTOCOLLMANAGEMENT = 'PROTOCOLLMANAGEMENT',
    RESOLUTIONS = 'RESOLUTIONS',
    ORGANIZATIONS = 'ORGANIZATIONS',
    CLAIM_COCKPIT = 'CLAIM_COCKPIT',
    INVESTIGATIONS = 'INVESTIGATIONS',
    PLAN_DELIVERY_LIST = 'PLAN_DELIVERY_LIST',
    VALUE_TABLE = 'VALUE_TABLE',
    PROJECT_MANAGMENT = 'PROJECT_MANAGMENT',
    BIM_ISSUES = 'BIM_ISSUES',
    DOCUMENTS_AND_PLANS = 'DOCUMENTS_AND_PLANS',
    KPI_DASHBOARD = 'KPI_DASHBOARD',
    STA_INTEGRATION = 'STA_INTEGRATION',
}
export enum API_OXSYNCFILEINFO_RELATIONS {
    MASTER = 'MASTER',
    SLAVE = 'SLAVE',
    SYMLINK = 'SYMLINK',
    ORIGINAL = 'ORIGINAL',
    TASK = 'TASK',
    WORKFLOW = 'WORKFLOW',
    QUESTION = 'QUESTION',
}
export enum API_OXSYNCFILEINFO_STATE {
    ACTIVE = 'ACTIVE',
    ARCHIVED = 'ARCHIVED',
    LOCKED = 'LOCKED',
    SYMLINK = 'SYMLINK',
    DELETED = 'DELETED',
    EXTERN_SYMLINK = 'EXTERN_SYMLINK',
}
export enum API_PAVEUSER_DASHBOARDLAYOUT {
    LIST = 'LIST',
    TILES = 'TILES',
    COMPACT = 'COMPACT',
}
export enum API_PAVEUSER_LASTENVIRONMENT {
    NONE = 'NONE',
    CLASSIC = 'CLASSIC',
    MODERN = 'MODERN',
}
export enum API_PAVEUSER_LAYOUTTYPE {
    SPLIT = 'SPLIT',
    LIST = 'LIST',
}
export enum API_PAVEUSER_MAILSIGNATUREOPTION {
    NONE = 'NONE',
    UNIFIED = 'UNIFIED',
    CUSTOM = 'CUSTOM',
}
export enum API_PAVEUSER_PROJECTROLE {
    ADMIN = 'ADMIN',
    USER = 'USER',
    HID = 'HID',
    INFO = 'INFO',
    ARCHIVE_ADMIN = 'ARCHIVE_ADMIN',
    NONE = 'NONE',
}
export enum API_PAVEUSER_TOKENTYPE2FA {
    STANDARD = 'STANDARD',
    TOTP = 'TOTP',
    SMS = 'SMS',
    WEBDAV = 'WEBDAV',
    EMAIL = 'EMAIL',
    FIDO = 'FIDO',
}
export enum API_PGADMINPROJECTCHANGES_NEWPROJECTSTATUS {
    ENABLED = 'ENABLED',
    ARCHIVED = 'ARCHIVED',
    DEACTIVATED = 'DEACTIVATED',
}
export enum API_PLANDELIVERYLIST_RIGHT {
    READ = 'READ',
    WRITE = 'WRITE',
    OWNER = 'OWNER',
    DENIED = 'DENIED',
}
export enum API_PLANDELIVERYLISTACL_PDLRIGHT {
    READ = 'READ',
    WRITE = 'WRITE',
    OWNER = 'OWNER',
    DENIED = 'DENIED',
}
export enum API_PLANDELIVERYLISTACL_SUBJECTTYPE {
    USER = 'USER',
    GROUP = 'GROUP',
    CONTACT = 'CONTACT',
}
export enum API_PLANDELIVERYLISTPACKAGE_REMINDSUBJECTSANDTYPES {
    USER = 'USER',
    GROUP = 'GROUP',
    CONTACT = 'CONTACT',
}
export enum API_PLANDELIVERYLISTPACKAGE_SUPPLIERIDANDTYPE {
    USER = 'USER',
    GROUP = 'GROUP',
    CONTACT = 'CONTACT',
}
export enum API_POSITIONCHANGEREQUEST_STRATEGY {
    LEAVE = 'LEAVE',
    RENUMBER_ALL = 'RENUMBER_ALL',
    SWAP = 'SWAP',
    RENUMBER_FOLLOWING = 'RENUMBER_FOLLOWING',
}
export enum API_PRINTJOBDELIVERYDETAILS_DELIVERYSTATUS {
    UNDEFINED = 'UNDEFINED',
    DELIVERED = 'DELIVERED',
}
export enum API_PRINTJOBDELIVERYDETAILS_RECIPIENTTYPE {
    INTERNAL_RECIPIENT = 'INTERNAL_RECIPIENT',
    DELIVERY_ADDRESS = 'DELIVERY_ADDRESS',
}
export enum API_PRINTJOBERROR_TYPE {
    NO_COPIES = 'NO_COPIES',
    ERROR = 'ERROR',
}
export enum API_PRINTJOBFILE_FOLDING {
    ROLLED = 'ROLLED',
    FILLING_20_MM = 'FILLING_20_MM',
    NO_FILLING = 'NO_FILLING',
    FILLING_STRIP = 'FILLING_STRIP',
    NOT_DEFINED = 'NOT_DEFINED',
}
export enum API_PRINTJOBFILE_PLOTTER {
    BLACK_WHITE = 'BLACK_WHITE',
    COLORED = 'COLORED',
    ORIGINAL = 'ORIGINAL',
    TRANSPARENT = 'TRANSPARENT',
    NOT_DEFINED = 'NOT_DEFINED',
}
export enum API_PRINTJOBPROVIDER_ORDERMODE {
    MAIL = 'MAIL',
    HTTP = 'HTTP',
    INTERN = 'INTERN',
}
export enum API_PROJECT_FUNCTIONS {
    METADATA = 'METADATA',
    FILEPREVIEW = 'FILEPREVIEW',
    FILENAMECHECK = 'FILENAMECHECK',
    AUTOMATICDIRMAPPING = 'AUTOMATICDIRMAPPING',
    ONLINEVIEWER = 'ONLINEVIEWER',
    PDFCONVERTATION = 'PDFCONVERTATION',
    FULLTEXTSEARCH = 'FULLTEXTSEARCH',
    OFFICE_VIEWER = 'OFFICE_VIEWER',
    PROJECT_INBOXES = 'PROJECT_INBOXES',
    FILECHECK = 'FILECHECK',
    EASYVIEWER = 'EASYVIEWER',
    WEBVIEWER = 'WEBVIEWER',
    WEBDAV = 'WEBDAV',
    WEBDAV_FOR_VIEWS = 'WEBDAV_FOR_VIEWS',
    WEBDAV_FOR_WORKFLOWS = 'WEBDAV_FOR_WORKFLOWS',
    PLANVIEW = 'PLANVIEW',
    REPORTS = 'REPORTS',
    BCF_VIEWER = 'BCF_VIEWER',
    BIM_VIEWER = 'BIM_VIEWER',
    FILE_DISTRIBUTION_MATRIX = 'FILE_DISTRIBUTION_MATRIX',
    FILE_LABELS = 'FILE_LABELS',
    SYNCHRONIZATION_BOX = 'SYNCHRONIZATION_BOX',
    SYNCHRONIZATION_PROBIS = 'SYNCHRONIZATION_PROBIS',
    SYNCHRONIZATION_BIM_COLLAB = 'SYNCHRONIZATION_BIM_COLLAB',
    EXTENDED_ZIP_UPLOAD = 'EXTENDED_ZIP_UPLOAD',
    AI_CHAT = 'AI_CHAT',
}
export enum API_PROJECT_GROUP_ADMIN_SORTBY {
    ID = 'ID',
    SERVER_NAME = 'SERVER_NAME',
    AUTH_URL = 'AUTH_URL',
    CUSTOMER_LOGIN_URL = 'CUSTOMER_LOGIN_URL',
}
export enum API_PROJECT_GROUP_ADMIN_SORTORDER {
    ASC = 'ASC',
    DESC = 'DESC',
}
export enum API_PROJECT_METHOD {
    NEW = 'NEW',
    TEMPLATE = 'TEMPLATE',
    PROJECTGROUP = 'PROJECTGROUP',
    NONE = 'NONE',
}
export enum API_PROJECT_PLANDELIVERYLISTRIGHTS {
    READ = 'READ',
    WRITE = 'WRITE',
    OWNER = 'OWNER',
    DENIED = 'DENIED',
}
export enum API_PROJECT_STARTWITH {
    MAIL = 'MAIL',
    DOCUMENTS = 'DOCUMENTS',
    VIEW = 'VIEW',
    QA = 'QA',
    BIM = 'BIM',
    TASKS = 'TASKS',
    WORKFLOW = 'WORKFLOW',
    TENDER_MODERN = 'TENDER_MODERN',
    TENDER = 'TENDER',
    LOP = 'LOP',
    CALENDAR = 'CALENDAR',
    OX_MODULES = 'OX_MODULES',
    CONSTRUCTIONLOG = 'CONSTRUCTIONLOG',
    ONLINEBAUABNAHME = 'ONLINEBAUABNAHME',
    OX_FOTOS = 'OX_FOTOS',
    OX_CHECKLISTS = 'OX_CHECKLISTS',
    CLAIMDOC = 'CLAIMDOC',
    WEBCAM = 'WEBCAM',
    EAKTE = 'EAKTE',
    CONTRACTMANAGEMENT = 'CONTRACTMANAGEMENT',
    PROTOCOLLMANAGEMENT = 'PROTOCOLLMANAGEMENT',
    RESOLUTIONS = 'RESOLUTIONS',
    ORGANIZATIONS = 'ORGANIZATIONS',
    CLAIM_COCKPIT = 'CLAIM_COCKPIT',
    INVESTIGATIONS = 'INVESTIGATIONS',
    PLAN_DELIVERY_LIST = 'PLAN_DELIVERY_LIST',
    VALUE_TABLE = 'VALUE_TABLE',
    PROJECT_MANAGMENT = 'PROJECT_MANAGMENT',
    BIM_ISSUES = 'BIM_ISSUES',
    DOCUMENTS_AND_PLANS = 'DOCUMENTS_AND_PLANS',
    KPI_DASHBOARD = 'KPI_DASHBOARD',
    STA_INTEGRATION = 'STA_INTEGRATION',
}
export enum API_PROJECT_TEMPLATE {
    PAVECDE = 'PAVECDE',
    PAVEEASY = 'PAVEEASY',
    PAVEBASIC = 'PAVEBASIC',
    PAVEBUSINESS = 'PAVEBUSINESS',
    PAVEENTERPRISE = 'PAVEENTERPRISE',
}
export enum API_PROJECT_USERROLE {
    ADMIN = 'ADMIN',
    USER = 'USER',
    HID = 'HID',
    INFO = 'INFO',
    ARCHIVE_ADMIN = 'ARCHIVE_ADMIN',
    NONE = 'NONE',
}
export enum API_PROJECTGROUP_USERLOGINMODE {
    STANDARD = 'STANDARD',
    TOTP = 'TOTP',
    SMS = 'SMS',
    WEBDAV = 'WEBDAV',
    EMAIL = 'EMAIL',
    FIDO = 'FIDO',
}
export enum API_PROJECTGROUPPAGINATION_SORTBY {
    NAME = 'NAME',
    SHORT_NAME = 'SHORT_NAME',
    DESCRIPTION = 'DESCRIPTION',
}
export enum API_PROJECTGROUPPAGINATION_SORTORDER {
    ASC = 'ASC',
    DESC = 'DESC',
}
export enum API_PROJECTGROUPS_SORTBY {
    NAME = 'NAME',
    SHORT_NAME = 'SHORT_NAME',
    DESCRIPTION = 'DESCRIPTION',
}
export enum API_PROJECTGROUPS_SORTORDER {
    ASC = 'ASC',
    DESC = 'DESC',
}
export enum API_PROJECTS_EXTENSION_TYPE {
    TOPIC = 'TOPIC',
    TITLE = 'TITLE',
    STATUS = 'STATUS',
    PRIORITY = 'PRIORITY',
    STAGE = 'STAGE',
    TYPE = 'TYPE',
    LABEL = 'LABEL',
    USER = 'USER',
    FILE = 'FILE',
}
export enum API_PROJECTS_TYPE {
    GROUP = 'GROUP',
    USER = 'USER',
}
export enum API_PROJECTSHORTINFO_ROLE {
    ADMIN = 'ADMIN',
    USER = 'USER',
    HID = 'HID',
    INFO = 'INFO',
    ARCHIVE_ADMIN = 'ARCHIVE_ADMIN',
    NONE = 'NONE',
}
export enum API_PROJECTUSER_USERPROJECTROLE {
    ADMIN = 'ADMIN',
    USER = 'USER',
    HID = 'HID',
    INFO = 'INFO',
    ARCHIVE_ADMIN = 'ARCHIVE_ADMIN',
    NONE = 'NONE',
}
export enum API_QA_ROLE {
    READ_ALL = 'READ_ALL',
    BUYER = 'BUYER',
    GATEKEEPER_BUYER = 'GATEKEEPER_BUYER',
    GATEKEEPER_SELLER = 'GATEKEEPER_SELLER',
    SPECIALIST = 'SPECIALIST',
    APPROVAL_CATEGORY = 'APPROVAL_CATEGORY',
    APPROVAL_FIRST_STAGE = 'APPROVAL_FIRST_STAGE',
    APPROVAL_SECOND_STAGE = 'APPROVAL_SECOND_STAGE',
}
export enum API_QA_SORTBY {
    LOCAL_ID = 'LOCAL_ID',
    TOPIC = 'TOPIC',
    CATEGORY = 'CATEGORY',
    PRIO = 'PRIO',
    ASKED_BY = 'ASKED_BY',
    CREATED = 'CREATED',
    STATUS = 'STATUS',
    TYPE = 'TYPE',
    PL_ANSWER = 'PL_ANSWER',
    EXPIRES_IN = 'EXPIRES_IN',
    ORGANISATION = 'ORGANISATION',
}
export enum API_QA_SORTORDER {
    ASC = 'ASC',
    DESC = 'DESC',
}
export enum API_QA_TYPE {
    PRIVATE = 'PRIVATE',
    PUBLIC = 'PUBLIC',
}
export enum API_QALISTFILTEROPTIONS_STATUS {
    UNKNOWN = 'UNKNOWN',
    DRAFT = 'DRAFT',
    WITHDRAWN = 'WITHDRAWN',
    IN_ADMISSION = 'IN_ADMISSION',
    NOT_ADMITTED = 'NOT_ADMITTED',
    IN_ACCEPTANCE = 'IN_ACCEPTANCE',
    NOT_ACCEPTED = 'NOT_ACCEPTED',
    ACCEPTED = 'ACCEPTED',
    IN_PROGRESS = 'IN_PROGRESS',
    IN_CATEGORY_APPROVAL = 'IN_CATEGORY_APPROVAL',
    IN_FIRST_STAGE_APPROVAL = 'IN_FIRST_STAGE_APPROVAL',
    IN_SECOND_STAGE_APPROVAL = 'IN_SECOND_STAGE_APPROVAL',
    ANSWER_REJECTED = 'ANSWER_REJECTED',
    APPROVED = 'APPROVED',
}
export enum API_QAQUESTIONCOUNT_ROLE {
    READ_ALL = 'READ_ALL',
    BUYER = 'BUYER',
    GATEKEEPER_BUYER = 'GATEKEEPER_BUYER',
    GATEKEEPER_SELLER = 'GATEKEEPER_SELLER',
    SPECIALIST = 'SPECIALIST',
    APPROVAL_CATEGORY = 'APPROVAL_CATEGORY',
    APPROVAL_FIRST_STAGE = 'APPROVAL_FIRST_STAGE',
    APPROVAL_SECOND_STAGE = 'APPROVAL_SECOND_STAGE',
}
export enum API_QASEARCH_CONNECTOR {
    AND = 'AND',
    OR = 'OR',
}
export enum API_QASEARCH_ROLE {
    READ_ALL = 'READ_ALL',
    BUYER = 'BUYER',
    GATEKEEPER_BUYER = 'GATEKEEPER_BUYER',
    GATEKEEPER_SELLER = 'GATEKEEPER_SELLER',
    SPECIALIST = 'SPECIALIST',
    APPROVAL_CATEGORY = 'APPROVAL_CATEGORY',
    APPROVAL_FIRST_STAGE = 'APPROVAL_FIRST_STAGE',
    APPROVAL_SECOND_STAGE = 'APPROVAL_SECOND_STAGE',
}
export enum API_QASEARCH_STATUS {
    UNKNOWN = 'UNKNOWN',
    DRAFT = 'DRAFT',
    WITHDRAWN = 'WITHDRAWN',
    IN_ADMISSION = 'IN_ADMISSION',
    NOT_ADMITTED = 'NOT_ADMITTED',
    IN_ACCEPTANCE = 'IN_ACCEPTANCE',
    NOT_ACCEPTED = 'NOT_ACCEPTED',
    ACCEPTED = 'ACCEPTED',
    IN_PROGRESS = 'IN_PROGRESS',
    IN_CATEGORY_APPROVAL = 'IN_CATEGORY_APPROVAL',
    IN_FIRST_STAGE_APPROVAL = 'IN_FIRST_STAGE_APPROVAL',
    IN_SECOND_STAGE_APPROVAL = 'IN_SECOND_STAGE_APPROVAL',
    ANSWER_REJECTED = 'ANSWER_REJECTED',
    APPROVED = 'APPROVED',
}
export enum API_QASETTINGS_QUESTIONERINFOVISIBLEFORSPECIALIST {
    NONE = 'NONE',
    ALL = 'ALL',
}
export enum API_QUESTION_PRIORITY {
    LOW = 'LOW',
    NORMAL = 'NORMAL',
    HIGH = 'HIGH',
}
export enum API_QUESTION_STATUS {
    UNKNOWN = 'UNKNOWN',
    DRAFT = 'DRAFT',
    WITHDRAWN = 'WITHDRAWN',
    IN_ADMISSION = 'IN_ADMISSION',
    NOT_ADMITTED = 'NOT_ADMITTED',
    IN_ACCEPTANCE = 'IN_ACCEPTANCE',
    NOT_ACCEPTED = 'NOT_ACCEPTED',
    ACCEPTED = 'ACCEPTED',
    IN_PROGRESS = 'IN_PROGRESS',
    IN_CATEGORY_APPROVAL = 'IN_CATEGORY_APPROVAL',
    IN_FIRST_STAGE_APPROVAL = 'IN_FIRST_STAGE_APPROVAL',
    IN_SECOND_STAGE_APPROVAL = 'IN_SECOND_STAGE_APPROVAL',
    ANSWER_REJECTED = 'ANSWER_REJECTED',
    APPROVED = 'APPROVED',
}
export enum API_QUESTIONLIMITRESPONSE_PERIOD {
    DAY = 'DAY',
    WEEK = 'WEEK',
    MONTH = 'MONTH',
    ALL = 'ALL',
}
export enum API_RELATIONINFO_TYPE {
    MASTER = 'MASTER',
    SLAVE = 'SLAVE',
    SYMLINK = 'SYMLINK',
    ORIGINAL = 'ORIGINAL',
    TASK = 'TASK',
    WORKFLOW = 'WORKFLOW',
    QUESTION = 'QUESTION',
}
export enum API_RELEASE_NOTES_LANGUAGE {
    DE = 'DE',
    EN = 'EN',
}
export enum API_RELEASENOTES_LANGUAGE {
    DE = 'DE',
    EN = 'EN',
}
export enum API_REPORTS_SCOPE {
    TOP_10 = 'TOP_10',
    TOP_100 = 'TOP_100',
    ALL = 'ALL',
}
export enum API_SCHEDULEDJOB_JOB {
    DELETEPROJECT = 'DELETEPROJECT',
    REMOVEUSER = 'REMOVEUSER',
    DEACTIVATEPRUSER = 'DEACTIVATEPRUSER',
}
export enum API_SCHEDULEDJOB_STATUS {
    CREATED = 'CREATED',
    NOTIFIED = 'NOTIFIED',
    EXECUTED = 'EXECUTED',
}
export enum API_SEARCHOPTIONS_SORTORDER {
    NAME = 'NAME',
    DESCRIPTION = 'DESCRIPTION',
    INDEX = 'INDEX',
    TYPE = 'TYPE',
    CREATED = 'CREATED',
    SIZE = 'SIZE',
    DIRECTORY = 'DIRECTORY',
    ID = 'ID',
    RELATION = 'RELATION',
    LAST_CHANGE = 'LAST_CHANGE',
    OWNER = 'OWNER',
    RELEVANCE = 'RELEVANCE',
}
export enum API_SEARCHRESULT_RELATIONS {
    MASTER = 'MASTER',
    SLAVE = 'SLAVE',
    SYMLINK = 'SYMLINK',
    ORIGINAL = 'ORIGINAL',
    TASK = 'TASK',
    WORKFLOW = 'WORKFLOW',
    QUESTION = 'QUESTION',
}
export enum API_SEARCHRESULT_STATE {
    ACTIVE = 'ACTIVE',
    ARCHIVED = 'ARCHIVED',
    LOCKED = 'LOCKED',
    SYMLINK = 'SYMLINK',
    DELETED = 'DELETED',
    EXTERN_SYMLINK = 'EXTERN_SYMLINK',
}
export enum API_SECURITYTOKEN_SPECIALMAILRIGHTS {
    VIEW = 'VIEW',
    VIEW_WATERMARKED = 'VIEW_WATERMARKED',
    READONLY = 'READONLY',
    WRITE = 'WRITE',
    OWNER_FILES = 'OWNER_FILES',
    OWNER_FILES_AND_FOLDERS = 'OWNER_FILES_AND_FOLDERS',
}
export enum API_SECURITYTOKEN_TOKENTYPE2FA {
    STANDARD = 'STANDARD',
    TOTP = 'TOTP',
    SMS = 'SMS',
    WEBDAV = 'WEBDAV',
    EMAIL = 'EMAIL',
    FIDO = 'FIDO',
}
export enum API_STATUS_STATUS {
    OK = 'OK',
}
export enum API_STATUSTYPE_FAMILY {
    INFORMATIONAL = 'INFORMATIONAL',
    SUCCESSFUL = 'SUCCESSFUL',
    REDIRECTION = 'REDIRECTION',
    CLIENT_ERROR = 'CLIENT_ERROR',
    SERVER_ERROR = 'SERVER_ERROR',
    OTHER = 'OTHER',
}
export enum API_STEPINFOREST_STATE {
    STARTED = 'STARTED',
    WAITING = 'WAITING',
    IN_PROGRESS = 'IN_PROGRESS',
    FINISHED = 'FINISHED',
    ABORTED = 'ABORTED',
    ERROR = 'ERROR',
    UNDEFINED = 'UNDEFINED',
}
export enum API_SUBTASKDATA_STATE {
    OPEN = 'OPEN',
    IN_PROGRESS = 'IN_PROGRESS',
    WAITING = 'WAITING',
    FINISHED = 'FINISHED',
    CANCELED = 'CANCELED',
}
export enum API_TABLEFORWORKFLOWSCOLUMNS_INPUTELEMENT {
    INPUT = 'INPUT',
    CURRENCY_INPUT = 'CURRENCY_INPUT',
}
export enum API_TASKDATA_PRIORITY {
    LOW = 'LOW',
    NORMAL = 'NORMAL',
    HIGH = 'HIGH',
}
export enum API_TASKDATA_STATE {
    OPEN = 'OPEN',
    IN_PROGRESS = 'IN_PROGRESS',
    WAITING = 'WAITING',
    FINISHED = 'FINISHED',
    CANCELED = 'CANCELED',
}
export enum API_TASKPAGINATION_SORTBY {
    NAME = 'NAME',
    PRIORITY = 'PRIORITY',
    DUE = 'DUE',
    STATE = 'STATE',
    ASSIGNEE = 'ASSIGNEE',
    PROGRESS = 'PROGRESS',
}
export enum API_TASKPAGINATION_SORTORDER {
    ASC = 'ASC',
    DESC = 'DESC',
}
export enum API_TASKREQUESTDATA_PRIORITY {
    LOW = 'LOW',
    NORMAL = 'NORMAL',
    HIGH = 'HIGH',
}
export enum API_TASKREQUESTDATA_STATE {
    OPEN = 'OPEN',
    IN_PROGRESS = 'IN_PROGRESS',
    WAITING = 'WAITING',
    FINISHED = 'FINISHED',
    CANCELED = 'CANCELED',
}
export enum API_TEMPLATES_SORTBY {
    NAME = 'NAME',
    DESCRIPTION = 'DESCRIPTION',
    INDEX = 'INDEX',
    TYPE = 'TYPE',
    CREATED = 'CREATED',
    SIZE = 'SIZE',
    DIRECTORY = 'DIRECTORY',
    ID = 'ID',
    RELATION = 'RELATION',
    LAST_CHANGE = 'LAST_CHANGE',
    OWNER = 'OWNER',
    RELEVANCE = 'RELEVANCE',
}
export enum API_TEMPLATES_SORTORDER {
    ASC = 'ASC',
    DESC = 'DESC',
}
export enum API_TENDER_DOCUMENTS_INCLUDEFILES {
    NONE = 'NONE',
    ACTIVE = 'ACTIVE',
    DIRECTORIES_ONLY = 'DIRECTORIES_ONLY',
    ALL = 'ALL',
}
export enum API_TENDER_GUEST_INCLUDEFILES {
    NONE = 'NONE',
    ACTIVE = 'ACTIVE',
    DIRECTORIES_ONLY = 'DIRECTORIES_ONLY',
    ALL = 'ALL',
}
export enum API_TENDER_ROLE {
    SUPPLIER_MANAGER = 'SUPPLIER_MANAGER',
    CALL_MANAGER = 'CALL_MANAGER',
    REVIEWER = 'REVIEWER',
    INSPECTOR = 'INSPECTOR',
    EVALUATOR = 'EVALUATOR',
    READ_ALL_CALLS = 'READ_ALL_CALLS',
    MAIL_TEMPLATES = 'MAIL_TEMPLATES',
    BIDDER = 'BIDDER',
}
export enum API_TENDER_SORTBY {
    NAME = 'NAME',
    LOCATION = 'LOCATION',
    REMARKS = 'REMARKS',
    ADDRESS = 'ADDRESS',
    EMAIL = 'EMAIL',
}
export enum API_TENDER_SORTORDER {
    ASC = 'ASC',
    DESC = 'DESC',
}
export enum API_TENDER_TIMEFILTERTYPE {
    FIXED = 'FIXED',
    DYNAMIC = 'DYNAMIC',
    SHOW_ALL = 'SHOW_ALL',
}
export enum API_TENDERCALLFILTER_STATUS {
    INITIALIZED = 'INITIALIZED',
    ABORTED = 'ABORTED',
    RUNNING = 'RUNNING',
    IN_REVIEW = 'IN_REVIEW',
    IN_INSPECTION = 'IN_INSPECTION',
    FINISHED = 'FINISHED',
}
export enum API_TENDERCALLPAGINATION_SORTORDER {
    ASC = 'ASC',
    DESC = 'DESC',
}
export enum API_TENDERMODULEACCESSLEVELS_BIDDERPOOLACCESS {
    FULL = 'FULL',
    READONLY = 'READONLY',
    DENIED = 'DENIED',
}
export enum API_TENDERMODULEACCESSLEVELS_TEMPLATESACCESS {
    FULL = 'FULL',
    READONLY = 'READONLY',
    DENIED = 'DENIED',
}
export enum API_TENDERMODULEACCESSLEVELS_TENDERCONTACTSACCESS {
    FULL = 'FULL',
    READONLY = 'READONLY',
    DENIED = 'DENIED',
}
export enum API_TENDERMODULEACCESSLEVELS_TENDERLISTACCESS {
    FULL = 'FULL',
    READONLY = 'READONLY',
    DENIED = 'DENIED',
}
export enum API_TENDERMODULEACCESSLEVELS_TRADESPOOLACCESS {
    FULL = 'FULL',
    READONLY = 'READONLY',
    DENIED = 'DENIED',
}
export enum API_THIRD_PARTY_API_MODULE {
    MAIL = 'MAIL',
    DOCUMENTS = 'DOCUMENTS',
    VIEW = 'VIEW',
    QA = 'QA',
    BIM = 'BIM',
    TASKS = 'TASKS',
    WORKFLOW = 'WORKFLOW',
    TENDER_MODERN = 'TENDER_MODERN',
    TENDER = 'TENDER',
    LOP = 'LOP',
    CALENDAR = 'CALENDAR',
    OX_MODULES = 'OX_MODULES',
    CONSTRUCTIONLOG = 'CONSTRUCTIONLOG',
    ONLINEBAUABNAHME = 'ONLINEBAUABNAHME',
    OX_FOTOS = 'OX_FOTOS',
    OX_CHECKLISTS = 'OX_CHECKLISTS',
    CLAIMDOC = 'CLAIMDOC',
    WEBCAM = 'WEBCAM',
    EAKTE = 'EAKTE',
    CONTRACTMANAGEMENT = 'CONTRACTMANAGEMENT',
    PROTOCOLLMANAGEMENT = 'PROTOCOLLMANAGEMENT',
    RESOLUTIONS = 'RESOLUTIONS',
    ORGANIZATIONS = 'ORGANIZATIONS',
    CLAIM_COCKPIT = 'CLAIM_COCKPIT',
    INVESTIGATIONS = 'INVESTIGATIONS',
    PLAN_DELIVERY_LIST = 'PLAN_DELIVERY_LIST',
    VALUE_TABLE = 'VALUE_TABLE',
    PROJECT_MANAGMENT = 'PROJECT_MANAGMENT',
    BIM_ISSUES = 'BIM_ISSUES',
    DOCUMENTS_AND_PLANS = 'DOCUMENTS_AND_PLANS',
    KPI_DASHBOARD = 'KPI_DASHBOARD',
    STA_INTEGRATION = 'STA_INTEGRATION',
}
export enum API_THIRD_PARTY_API_SORTBY {
    NAME = 'NAME',
    DESCRIPTION = 'DESCRIPTION',
    INDEX = 'INDEX',
    TYPE = 'TYPE',
    CREATED = 'CREATED',
    SIZE = 'SIZE',
    DIRECTORY = 'DIRECTORY',
    ID = 'ID',
    RELATION = 'RELATION',
    LAST_CHANGE = 'LAST_CHANGE',
    OWNER = 'OWNER',
    RELEVANCE = 'RELEVANCE',
}
export enum API_THIRD_PARTY_API_SORTORDER {
    ASC = 'ASC',
    DESC = 'DESC',
}
export enum API_THIRDPARTYPROJECT_USERROLE {
    ADMIN = 'ADMIN',
    USER = 'USER',
    HID = 'HID',
    INFO = 'INFO',
    ARCHIVE_ADMIN = 'ARCHIVE_ADMIN',
    NONE = 'NONE',
}
export enum API_TIMEFILTER_DYNAMICTIMEUNIT {
    DAYS = 'DAYS',
    WEEKS = 'WEEKS',
    MONTHS = 'MONTHS',
    YEARS = 'YEARS',
}
export enum API_TIMEFILTER_TIMEFILTERTYPE {
    FIXED = 'FIXED',
    DYNAMIC = 'DYNAMIC',
    SHOW_ALL = 'SHOW_ALL',
}
export enum API_TRADESDATA_ACCESSLEVEL {
    FULL = 'FULL',
    READONLY = 'READONLY',
    DENIED = 'DENIED',
}
export enum API_TREEELEMENT_LINKTYPE {
    LINKED_INTERN = 'LINKED_INTERN',
    LINKED_EXTERN = 'LINKED_EXTERN',
    LINKED_EXTERN_SUB = 'LINKED_EXTERN_SUB',
}
export enum API_UPLOADDATA_EXTRACT_MODE {
    NONE = 'NONE',
    EXTRACT_FLAT = 'EXTRACT_FLAT',
    EXTRACT_WITH_DIRECTORY = 'EXTRACT_WITH_DIRECTORY',
    EXTRACT_WITH_EMPTY_DIRECTORY = 'EXTRACT_WITH_EMPTY_DIRECTORY',
}
export enum API_UPLOADERRORINFO_STATUS {
    INIT = 'INIT',
    OK = 'OK',
    REPLACE = 'REPLACE',
    WHICHFILE = 'WHICHFILE',
    MISSINGMETADATUM = 'MISSINGMETADATUM',
    RENAMEFILE = 'RENAMEFILE',
    FILENAMECONVENTION_FILENAME = 'FILENAMECONVENTION_FILENAME',
    FILENAMECONVENTION_FILETYPE = 'FILENAMECONVENTION_FILETYPE',
    DUPLICATE = 'DUPLICATE',
    INDEX = 'INDEX',
    LOCK = 'LOCK',
    NO_PDF = 'NO_PDF',
    ERROR = 'ERROR',
    VIEW_NO_AUTOMAPPING = 'VIEW_NO_AUTOMAPPING',
    MISSING_DESCRIPTION = 'MISSING_DESCRIPTION',
    ZIP_DIRECTORY = 'ZIP_DIRECTORY',
    EMPTY_FILE = 'EMPTY_FILE',
    DELETED_DIR = 'DELETED_DIR',
}
export enum API_UPLOADFILE_EXTRACTMODE {
    NONE = 'NONE',
    EXTRACT_FLAT = 'EXTRACT_FLAT',
    EXTRACT_WITH_DIRECTORY = 'EXTRACT_WITH_DIRECTORY',
    EXTRACT_WITH_EMPTY_DIRECTORY = 'EXTRACT_WITH_EMPTY_DIRECTORY',
}
export enum API_UPLOADFILE_EXTRACTMODES {
    NONE = 'NONE',
    EXTRACT_FLAT = 'EXTRACT_FLAT',
    EXTRACT_WITH_DIRECTORY = 'EXTRACT_WITH_DIRECTORY',
    EXTRACT_WITH_EMPTY_DIRECTORY = 'EXTRACT_WITH_EMPTY_DIRECTORY',
}
export enum API_UPLOADFILE_UPLOADSTATUS {
    INIT = 'INIT',
    OK = 'OK',
    REPLACE = 'REPLACE',
    WHICHFILE = 'WHICHFILE',
    MISSINGMETADATUM = 'MISSINGMETADATUM',
    RENAMEFILE = 'RENAMEFILE',
    FILENAMECONVENTION_FILENAME = 'FILENAMECONVENTION_FILENAME',
    FILENAMECONVENTION_FILETYPE = 'FILENAMECONVENTION_FILETYPE',
    DUPLICATE = 'DUPLICATE',
    INDEX = 'INDEX',
    LOCK = 'LOCK',
    NO_PDF = 'NO_PDF',
    ERROR = 'ERROR',
    VIEW_NO_AUTOMAPPING = 'VIEW_NO_AUTOMAPPING',
    MISSING_DESCRIPTION = 'MISSING_DESCRIPTION',
    ZIP_DIRECTORY = 'ZIP_DIRECTORY',
    EMPTY_FILE = 'EMPTY_FILE',
    DELETED_DIR = 'DELETED_DIR',
}
export enum API_UPLOADINFO_MODEEXISTS {
    REPLACE = 'REPLACE',
    ERROR = 'ERROR',
    LFDNR = 'LFDNR',
}
export enum API_UPLOADITEM_REPLACE {
    UNDEFINED = 'UNDEFINED',
    REPLACE_EXISTING = 'REPLACE_EXISTING',
    AUTO_RENAME_NEW = 'AUTO_RENAME_NEW',
    KEEP_EXISTING = 'KEEP_EXISTING',
}
export enum API_UPLOADITEM_TYPE {
    TEMP_FILE = 'TEMP_FILE',
    PROJECT_FILE = 'PROJECT_FILE',
}
export enum API_UPLOADPACKAGE_GLOBALREPLACE {
    UNDEFINED = 'UNDEFINED',
    REPLACE_EXISTING = 'REPLACE_EXISTING',
    AUTO_RENAME_NEW = 'AUTO_RENAME_NEW',
    KEEP_EXISTING = 'KEEP_EXISTING',
}
export enum API_USER_PROJECTROLE {
    ADMIN = 'ADMIN',
    USER = 'USER',
    HID = 'HID',
    INFO = 'INFO',
    ARCHIVE_ADMIN = 'ARCHIVE_ADMIN',
    NONE = 'NONE',
}
export enum API_USER_TOKENTYPE {
    STANDARD = 'STANDARD',
    TOTP = 'TOTP',
    SMS = 'SMS',
    WEBDAV = 'WEBDAV',
    EMAIL = 'EMAIL',
    FIDO = 'FIDO',
}
export enum API_USERANDLOPRIGHT_RIGHT {
    READ = 'READ',
    WRITE = 'WRITE',
    OWNER = 'OWNER',
}
export enum API_USERANDPDLRIGHT_RIGHT {
    READ = 'READ',
    WRITE = 'WRITE',
    OWNER = 'OWNER',
    DENIED = 'DENIED',
}
export enum API_USERDATA_DASHBOARDLAYOUT {
    LIST = 'LIST',
    TILES = 'TILES',
    COMPACT = 'COMPACT',
}
export enum API_USERDATA_LASTENVIRONMENT {
    NONE = 'NONE',
    CLASSIC = 'CLASSIC',
    MODERN = 'MODERN',
}
export enum API_USERDATA_LAYOUTTYPE {
    SPLIT = 'SPLIT',
    LIST = 'LIST',
}
export enum API_USERDATA_MAILSIGNATUREOPTION {
    NONE = 'NONE',
    UNIFIED = 'UNIFIED',
    CUSTOM = 'CUSTOM',
}
export enum API_USERDATA_PROJECTROLE {
    ADMIN = 'ADMIN',
    USER = 'USER',
    HID = 'HID',
    INFO = 'INFO',
    ARCHIVE_ADMIN = 'ARCHIVE_ADMIN',
    NONE = 'NONE',
}
export enum API_USERDATA_TOKENTYPE2FA {
    STANDARD = 'STANDARD',
    TOTP = 'TOTP',
    SMS = 'SMS',
    WEBDAV = 'WEBDAV',
    EMAIL = 'EMAIL',
    FIDO = 'FIDO',
}
export enum API_USERFILTER_PROJECTGROUPROLE {
    ADMIN = 'ADMIN',
    USER = 'USER',
}
export enum API_USERINPOOL_ROLES {
    SUPPLIER_MANAGER = 'SUPPLIER_MANAGER',
    CALL_MANAGER = 'CALL_MANAGER',
    REVIEWER = 'REVIEWER',
    INSPECTOR = 'INSPECTOR',
    EVALUATOR = 'EVALUATOR',
    READ_ALL_CALLS = 'READ_ALL_CALLS',
    MAIL_TEMPLATES = 'MAIL_TEMPLATES',
    BIDDER = 'BIDDER',
}
export enum API_USERLOGINSETTING_AVAILABLETYPES {
    STANDARD = 'STANDARD',
    TOTP = 'TOTP',
    SMS = 'SMS',
    WEBDAV = 'WEBDAV',
    EMAIL = 'EMAIL',
    FIDO = 'FIDO',
}
export enum API_USERLOGINSETTING_LOGINTYPE {
    STANDARD = 'STANDARD',
    TOTP = 'TOTP',
    SMS = 'SMS',
    WEBDAV = 'WEBDAV',
    EMAIL = 'EMAIL',
    FIDO = 'FIDO',
}
export enum API_USERPAGINATION_SORTBY {
    USER_ID = 'USER_ID',
    ID = 'ID',
    SURNAME = 'SURNAME',
    FIRST_NAME = 'FIRST_NAME',
    EMAIL = 'EMAIL',
    COMPANY = 'COMPANY',
}
export enum API_USERPAGINATION_SORTORDER {
    ASC = 'ASC',
    DESC = 'DESC',
}
export enum API_USERPRINTJOBPROVIDER_PROJECTROLE {
    ADMIN = 'ADMIN',
    USER = 'USER',
    HID = 'HID',
    INFO = 'INFO',
    ARCHIVE_ADMIN = 'ARCHIVE_ADMIN',
    NONE = 'NONE',
}
export enum API_USERPRINTJOBPROVIDER_TOKENTYPE {
    STANDARD = 'STANDARD',
    TOTP = 'TOTP',
    SMS = 'SMS',
    WEBDAV = 'WEBDAV',
    EMAIL = 'EMAIL',
    FIDO = 'FIDO',
}
export enum API_USERPROJECTROLES_PROJECTROLE {
    ADMIN = 'ADMIN',
    USER = 'USER',
    HID = 'HID',
    INFO = 'INFO',
    ARCHIVE_ADMIN = 'ARCHIVE_ADMIN',
    NONE = 'NONE',
}
export enum API_USERS_PROJECTGROUPROLE {
    ADMIN = 'ADMIN',
    USER = 'USER',
}
export enum API_USERS_SORTBY {
    USER_ID = 'USER_ID',
    ID = 'ID',
    SURNAME = 'SURNAME',
    FIRST_NAME = 'FIRST_NAME',
    EMAIL = 'EMAIL',
    COMPANY = 'COMPANY',
}
export enum API_USERS_SORTORDER {
    ASC = 'ASC',
    DESC = 'DESC',
}
export enum API_USERSELFSETTINGS_DASHBOARDLAYOUT {
    LIST = 'LIST',
    TILES = 'TILES',
    COMPACT = 'COMPACT',
}
export enum API_USERSELFSETTINGS_LANGUAGE {
    DE = 'DE',
    EN = 'EN',
}
export enum API_USERSELFSETTINGS_LAYOUTTYPE {
    SPLIT = 'SPLIT',
    LIST = 'LIST',
}
export enum API_USERSELFSETTINGS_MAILSIGNATUREOPTION {
    NONE = 'NONE',
    UNIFIED = 'UNIFIED',
    CUSTOM = 'CUSTOM',
}
export enum API_USERSETTINGS_DASHBOARDLAYOUT {
    LIST = 'LIST',
    TILES = 'TILES',
    COMPACT = 'COMPACT',
}
export enum API_USERSETTINGS_LANGUAGE {
    DE = 'DE',
    EN = 'EN',
}
export enum API_USERSETTINGS_LAYOUTTYPE {
    SPLIT = 'SPLIT',
    LIST = 'LIST',
}
export enum API_USERSETTINGS_MAILSIGNATUREOPTION {
    NONE = 'NONE',
    UNIFIED = 'UNIFIED',
    CUSTOM = 'CUSTOM',
}
export enum API_USERTECINFO_LASTENV {
    NONE = 'NONE',
    CLASSIC = 'CLASSIC',
    MODERN = 'MODERN',
}
export enum API_VALUETABLEACL_RIGHT {
    OWNER = 'OWNER',
    READ = 'READ',
    WRITE = 'WRITE',
    DENIED = 'DENIED',
}
export enum API_VALUETABLEACL_SUBJECTTYPE {
    USER = 'USER',
    GROUP = 'GROUP',
}
export enum API_VALUETABLEATTRIBUTE_DATATYPE {
    STRING = 'STRING',
    INTEGER = 'INTEGER',
    DOUBLE = 'DOUBLE',
    FLOAT = 'FLOAT',
    BOOLEAN = 'BOOLEAN',
    DATE = 'DATE',
    SYSUSER = 'SYSUSER',
    SYSGROUP = 'SYSGROUP',
    METADATA = 'METADATA',
    TEXTBOX = 'TEXTBOX',
    LIST = 'LIST',
    FOLDER = 'FOLDER',
    AUTOINC = 'AUTOINC',
}
export enum API_VERZEICHNISDATA_CREATIONSOURCE {
    USER_CREATION = 'USER_CREATION',
    AUTO_MAPPING = 'AUTO_MAPPING',
    CLONING = 'CLONING',
    ZIP_UPLOAD = 'ZIP_UPLOAD',
}
export enum API_VERZEICHNISDATA_MODULE {
    SYSTEM = 'SYSTEM',
    DOCUMENTS = 'DOCUMENTS',
    WEBCAM = 'WEBCAM',
    COMMUNICATION = 'COMMUNICATION',
    QA = 'QA',
    WORKFLOW = 'WORKFLOW',
    OLD_BAUTAGEBUCH = 'OLD_BAUTAGEBUCH',
    OLD_PCM = 'OLD_PCM',
    OLD_TASKMANAGER = 'OLD_TASKMANAGER',
    OLD_CLAIM = 'OLD_CLAIM',
    BCF_SERVER = 'BCF_SERVER',
}
export enum API_VERZEICHNISDATA_STORAGE {
    DOCUMENTS = 'DOCUMENTS',
    TEMPLATES = 'TEMPLATES',
    WEBCAM = 'WEBCAM',
    MAILATTACHMENTS = 'MAILATTACHMENTS',
    EXTERNAL_MAILS_SOURCE = 'EXTERNAL_MAILS_SOURCE',
    QA_ATTACHMENTS = 'QA_ATTACHMENTS',
    WORKFLOWFILES = 'WORKFLOWFILES',
    FILE_THUMBNAILS = 'FILE_THUMBNAILS',
    FULLTEXTSEARCH = 'FULLTEXTSEARCH',
    EASYVIEWER_CACHE = 'EASYVIEWER_CACHE',
    PR_LOGO = 'PR_LOGO',
    AI_DATA = 'AI_DATA',
    OLD_BAUTAGEBUCH = 'OLD_BAUTAGEBUCH',
    OLD_PCM = 'OLD_PCM',
    OLD_TASKMANAGER = 'OLD_TASKMANAGER',
    OLD_CLAIM = 'OLD_CLAIM',
    BCF = 'BCF',
    BCF_SNIPPET = 'BCF_SNIPPET',
    BCF_DOCUMENTS = 'BCF_DOCUMENTS',
    MODULE_DOCUMENT = 'MODULE_DOCUMENT',
}
export enum API_VIEWFILTER_SORTBY {
    FILE_NAME = 'FILE_NAME',
    INDEX = 'INDEX',
    UPDATED = 'UPDATED',
    DESCRIPTION = 'DESCRIPTION',
    TYPE = 'TYPE',
    METADATA = 'METADATA',
}
export enum API_VIEWFILTER_SORTORDER {
    ASC = 'ASC',
    DESC = 'DESC',
}
export enum API_VIEWINFORMATION_RELATIONS {
    MASTER = 'MASTER',
    SLAVE = 'SLAVE',
    SYMLINK = 'SYMLINK',
    ORIGINAL = 'ORIGINAL',
    TASK = 'TASK',
    WORKFLOW = 'WORKFLOW',
    QUESTION = 'QUESTION',
}
export enum API_VIEWINFORMATION_STATE {
    ACTIVE = 'ACTIVE',
    ARCHIVED = 'ARCHIVED',
    LOCKED = 'LOCKED',
    SYMLINK = 'SYMLINK',
    DELETED = 'DELETED',
    EXTERN_SYMLINK = 'EXTERN_SYMLINK',
}
export enum API_VIEWINFORMATION_VIEWRIGHT {
    VIEW = 'VIEW',
    VIEW_WATERMARKED = 'VIEW_WATERMARKED',
    READONLY = 'READONLY',
    WRITE = 'WRITE',
    OWNER_FILES = 'OWNER_FILES',
    OWNER_FILES_AND_FOLDERS = 'OWNER_FILES_AND_FOLDERS',
}
export enum API_VIEWREQUEST_SORTBY {
    FILE_NAME = 'FILE_NAME',
    INDEX = 'INDEX',
    UPDATED = 'UPDATED',
    DESCRIPTION = 'DESCRIPTION',
    TYPE = 'TYPE',
    METADATA = 'METADATA',
}
export enum API_VIEWREQUEST_SORTORDER {
    ASC = 'ASC',
    DESC = 'DESC',
}
export enum API_WFRDOBJECT_ACTIONTYPE {
    INFOMAIL = 'INFOMAIL',
    PLANVERTEILUNG = 'PLANVERTEILUNG',
    CALCULATE = 'CALCULATE',
    MAXDAUER = 'MAXDAUER',
    GUI = 'GUI',
    DATEISTATUS = 'DATEISTATUS',
    CREATEDIRECTORY = 'CREATEDIRECTORY',
    SETDIRECTORY = 'SETDIRECTORY',
    CREATEWERTE = 'CREATEWERTE',
    SETMETADATEN = 'SETMETADATEN',
    DATEIART = 'DATEIART',
    DATEISPEICHERN = 'DATEISPEICHERN',
    ONLINEBAUABNAHME = 'ONLINEBAUABNAHME',
    NEWFILE = 'NEWFILE',
    EXCELCHANGE = 'EXCELCHANGE',
    NOTIZ = 'NOTIZ',
    CUSTOMPDF = 'CUSTOMPDF',
    PDFCONVERTER = 'PDFCONVERTER',
    WORKFLOWDETAILS = 'WORKFLOWDETAILS',
    WORKFLOWSTART = 'WORKFLOWSTART',
    WORKFLOWSETINFO = 'WORKFLOWSETINFO',
    GW_DECISION = 'GW_DECISION',
    GW_SPLIT = 'GW_SPLIT',
    GW_JOIN = 'GW_JOIN',
    GW_CANCEL_OTHER_STEPS = 'GW_CANCEL_OTHER_STEPS',
    DELETESYMLINK = 'DELETESYMLINK',
    WAITINGEXTERN = 'WAITINGEXTERN',
    MERGEANNOTATION = 'MERGEANNOTATION',
    COPYFILESWITHANNOTATIONS = 'COPYFILESWITHANNOTATIONS',
    PROBISAPI = 'PROBISAPI',
    NOP = 'NOP',
    OPENPOINT = 'OPENPOINT',
    IFCROOMBOOK = 'IFCROOMBOOK',
    MODELCHECK = 'MODELCHECK',
    PROBISINVOICE = 'PROBISINVOICE',
    PROBISCONTRACTTITLE = 'PROBISCONTRACTTITLE',
    EXTERNALURL = 'EXTERNALURL',
    DATEILOCK = 'DATEILOCK',
    TABLE = 'TABLE',
    MERGEFILES = 'MERGEFILES',
}
export enum API_WFRDOBJECT_STEPTYPE {
    SYSTEM = 'SYSTEM',
    HUMANTASK = 'HUMANTASK',
}
export enum API_WORDDATA_DATATYPE {
    TERMS = 'TERMS',
    TOPICS = 'TOPICS',
}
export enum API_WORKFLOWFLOWCHARTOBJECT_TYPE {
    INFOMAIL = 'INFOMAIL',
    PLANVERTEILUNG = 'PLANVERTEILUNG',
    CALCULATE = 'CALCULATE',
    MAXDAUER = 'MAXDAUER',
    GUI = 'GUI',
    DATEISTATUS = 'DATEISTATUS',
    CREATEDIRECTORY = 'CREATEDIRECTORY',
    SETDIRECTORY = 'SETDIRECTORY',
    CREATEWERTE = 'CREATEWERTE',
    SETMETADATEN = 'SETMETADATEN',
    DATEIART = 'DATEIART',
    DATEISPEICHERN = 'DATEISPEICHERN',
    ONLINEBAUABNAHME = 'ONLINEBAUABNAHME',
    NEWFILE = 'NEWFILE',
    EXCELCHANGE = 'EXCELCHANGE',
    NOTIZ = 'NOTIZ',
    CUSTOMPDF = 'CUSTOMPDF',
    PDFCONVERTER = 'PDFCONVERTER',
    WORKFLOWDETAILS = 'WORKFLOWDETAILS',
    WORKFLOWSTART = 'WORKFLOWSTART',
    WORKFLOWSETINFO = 'WORKFLOWSETINFO',
    GW_DECISION = 'GW_DECISION',
    GW_SPLIT = 'GW_SPLIT',
    GW_JOIN = 'GW_JOIN',
    GW_CANCEL_OTHER_STEPS = 'GW_CANCEL_OTHER_STEPS',
    DELETESYMLINK = 'DELETESYMLINK',
    WAITINGEXTERN = 'WAITINGEXTERN',
    MERGEANNOTATION = 'MERGEANNOTATION',
    COPYFILESWITHANNOTATIONS = 'COPYFILESWITHANNOTATIONS',
    PROBISAPI = 'PROBISAPI',
    NOP = 'NOP',
    OPENPOINT = 'OPENPOINT',
    IFCROOMBOOK = 'IFCROOMBOOK',
    MODELCHECK = 'MODELCHECK',
    PROBISINVOICE = 'PROBISINVOICE',
    PROBISCONTRACTTITLE = 'PROBISCONTRACTTITLE',
    EXTERNALURL = 'EXTERNALURL',
    DATEILOCK = 'DATEILOCK',
    TABLE = 'TABLE',
    MERGEFILES = 'MERGEFILES',
}
export enum API_WORKFLOWINFOREST_STATE {
    STARTED = 'STARTED',
    WAITING = 'WAITING',
    IN_PROGRESS = 'IN_PROGRESS',
    FINISHED = 'FINISHED',
    ABORTED = 'ABORTED',
    ERROR = 'ERROR',
    UNDEFINED = 'UNDEFINED',
}
export enum API_WORKFLOWS_FILTER {
    HUMAN_AND_GW = 'HUMAN_AND_GW',
}
export enum API_WORKFLOWSEARCH_SCOPE {
    ALL = 'ALL',
    OWN = 'OWN',
}
export enum API_WORKFLOWSEARCH_STATUS {
    STARTED = 'STARTED',
    FINISHED = 'FINISHED',
    ABORTED = 'ABORTED',
    ERROR = 'ERROR',
}
export enum API_WORKFLOWSEARCHREQUEST_SCOPE {
    ALL = 'ALL',
    OWN = 'OWN',
}
export enum API_WORKFLOWSEARCHREQUEST_STATUS {
    STARTED = 'STARTED',
    FINISHED = 'FINISHED',
    ABORTED = 'ABORTED',
    ERROR = 'ERROR',
}
export enum API_WORKFLOWSEARCHRESPONSE_SCOPE {
    ALL = 'ALL',
    OWN = 'OWN',
}
export enum API_WORKFLOWSEARCHRESPONSE_STATUS {
    STARTED = 'STARTED',
    FINISHED = 'FINISHED',
    ABORTED = 'ABORTED',
    ERROR = 'ERROR',
}
export enum API_WORKFLOWSTARTDEFINITION_STARTFROM {
    MAIL = 'MAIL',
    DOCUMENTS = 'DOCUMENTS',
    VIEW = 'VIEW',
    QA = 'QA',
    BIM = 'BIM',
    TASKS = 'TASKS',
    WORKFLOW = 'WORKFLOW',
    TENDER_MODERN = 'TENDER_MODERN',
    TENDER = 'TENDER',
    LOP = 'LOP',
    CALENDAR = 'CALENDAR',
    OX_MODULES = 'OX_MODULES',
    CONSTRUCTIONLOG = 'CONSTRUCTIONLOG',
    ONLINEBAUABNAHME = 'ONLINEBAUABNAHME',
    OX_FOTOS = 'OX_FOTOS',
    OX_CHECKLISTS = 'OX_CHECKLISTS',
    CLAIMDOC = 'CLAIMDOC',
    WEBCAM = 'WEBCAM',
    EAKTE = 'EAKTE',
    CONTRACTMANAGEMENT = 'CONTRACTMANAGEMENT',
    PROTOCOLLMANAGEMENT = 'PROTOCOLLMANAGEMENT',
    RESOLUTIONS = 'RESOLUTIONS',
    ORGANIZATIONS = 'ORGANIZATIONS',
    CLAIM_COCKPIT = 'CLAIM_COCKPIT',
    INVESTIGATIONS = 'INVESTIGATIONS',
    PLAN_DELIVERY_LIST = 'PLAN_DELIVERY_LIST',
    VALUE_TABLE = 'VALUE_TABLE',
    PROJECT_MANAGMENT = 'PROJECT_MANAGMENT',
    BIM_ISSUES = 'BIM_ISSUES',
    DOCUMENTS_AND_PLANS = 'DOCUMENTS_AND_PLANS',
    KPI_DASHBOARD = 'KPI_DASHBOARD',
    STA_INTEGRATION = 'STA_INTEGRATION',
}
export enum API_WORKLISTENTRYREST_STATUS {
    STARTED = 'STARTED',
    WAITING = 'WAITING',
    IN_PROGRESS = 'IN_PROGRESS',
    FINISHED = 'FINISHED',
    ABORTED = 'ABORTED',
    ERROR = 'ERROR',
    UNDEFINED = 'UNDEFINED',
}
export enum API_WORKLISTENTRYREST_WORKLISTTYPE {
    MY = 'MY',
    DEPUTY = 'DEPUTY',
}
